































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { UmbrellaModel, UmbrellaType } from "@/models/products/umbrella";
import { Component, Watch, Prop } from "vue-property-decorator";
import Items from "./Items";
import RadioButtonBox from "@/components/elements/utility/RadioButtonBox.vue";
import AccordionSection from "@/components/elements/accordion/AccordionSection.vue";
import {
  LineItem,
  Note,
  SharedDesignOrigin
} from "@/models/order/order";
import { ProductType } from "@/models/products/product";
import * as option from "@/models/configurator/configurator_options";
import AddToQuoteFooter from "@/components/footer/AddToQuoteFooter.vue";
import ProductService, {
  SKU_UNAVAILABLE
} from "@/services/product_service";
import { AuthError, GenericError } from "@/services/error_service";
import { NotificationService } from "@/services/notification_service";
import ConfigFileService from "@/services/config_file_service";
import {
  ResolvedSharedConfig,
  SharedConfigLine
} from "@/models/configurator/shared_config";
import {
  designKey,
  designBaseMissing,
  designCoverMissing,
  judgeSharedDesign,
  markSharedDesignAdjusted,
  sharedDesignCode,
  sharedDesignOrigin,
  stampSharedDesign,
  stampSharedDesignOrigin,
  UNRESOLVED_DESIGN_KEY
} from "@/utility/shared_design";
import {
  resolveSharedBaseSelection,
  buildBaseLine,
  buildTopCoverLine,
  baseSelectionSignature,
  baseLineDesignKey,
  baseOptionsForLine,
  topCoverLineModel,
  ResolvedBaseSelection,
  SPIGOT_NOTE,
  BEAUTY_PLATE_NOTE
} from "@/utility/shared_design_lines";
import {
  findSetupGroups,
  mintSetupId,
  setupGroupAt,
  setupIdOf,
  stampSetup,
  syncSetupQty
} from "@/utility/line_setup";
import {
  BaseSelection,
  BaseSelectionChange,
  SPIGOT_STEM
} from "@/models/configurator/base_selection";
import BaseSelector from "@/components/items/BaseSelector.vue";
import JumpLinks, {
  JumpLinkSection
} from "@/components/elements/utility/JumpLinks.vue";
import ConfigCodeButton from "@/components/elements/ConfigCodeButton.vue";
import { FabricComponent } from "@/models/configurator/fabric_components";
import FabricSelector from "@/components/items/fabric_picker/FabricSelector.vue";
import MiniSwatch from "@/components/elements/products/MiniSwatch.vue";
import DeleteSwatch from "@/components/elements/utility/DeleteSwatch.vue";
import { CustomUmbrellaOrder } from "@/models/configurator/custom_umbrella";
import { FabricSwatch, FixedFabricArray } from "@/models/products/fabric";
import { ribAttachment, grommetOnlyModels } from "@/mixins/business_logic/rib_rules";
import { hasFinial } from "@/mixins/business_logic/finial_rules";
import { hasBottomPole } from "@/mixins/business_logic/bottompole_rules";
import { ProductLineName } from "@/models/products/collection";
import { Validations } from "vuelidate-property-decorators";
import {
  maxLength,
  minLength,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import { arrayLenEven } from "@/validators/custom";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import { EventBus } from "@/event-bus";
import { ConfigFile } from "@/models/configurator/config_file";
import { NoteFields } from "@/models/order/helpers";
import { FinishDisplayName, FinishHandle } from "@/models/products/finish";
import DropdownFinishes from "@/components/elements/utility/DropdownFinishes.vue";
import Dropdown from "@/components/elements/utility/Dropdown.vue";
import SpecsModal from "@/components/elements/modal/SpecsModal.vue";
import ConfirmDesignDeviation from "@/components/elements/modal/ConfirmDesignDeviation.vue";
import { formatTitle, getFinishImage } from "@/utility/helpers";
import { StoreModule } from "@/store/types";
import {
  GlobalActions,
  GlobalGetters
} from "@/store/modules/global/types";
import { OrderActions } from "@/store/modules/order/types";
import { Roles } from "@/models/user/roles";
import { PriceLevel } from "@/models/netsuite/netsuite";
import { namespace } from "vuex-class";

@Component({
  components: {
    AccordionSection,
    RadioButtonBox,
    AddToQuoteFooter,
    FabricSelector,
    MiniSwatch,
    DeleteSwatch,
    FormValidation,
    DropdownFinishes,
    Dropdown,
    SpecsModal,
    ConfirmDesignDeviation,
    BaseSelector,
    JumpLinks,
    ConfigCodeButton
  }
})
export default class CustomizeUmbrella extends Items {
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: Roles | null;
  /** FUPOF-193: a setup save rewrites up to three lines in one commit. */
  @(namespace(StoreModule.Order).Action(OrderActions.ReplaceLineItems))
  replaceLineItems!: (value: LineItem[]) => Promise<void>;

  protected isStockOnly = true;
  protected configFileService = new ConfigFileService();
  /**
   * FUPOF-193: set when this page was preloaded from a Shade Designer
   * configuration code. Stamps the resulting cart lines' provenance.
   */
  protected sharedDesignId: string | null = null;
  /**
   * FUPOF-193: the base the rep has chosen on this page, and its pricing.
   *
   * Held here rather than on `item_details` on purpose. `configFingerprint`
   * stringifies everything on `item_details` bar notes and the share marker, so
   * a `base` key would drop a whole ~12KB catalog document — `updated_at` and
   * all — into the umbrella's fingerprint, and a base fetch resolving after
   * captureSharedBaseline's $nextTick would silently retire the provenance pill
   * on a design nobody touched. It also keeps the key out of the
   * `v-bind.sync="item_details"` bindings, which never declared it.
   */
  protected baseSelection: BaseSelection | null = null;
  /** The last Add to Quote here saved a base (and any cover) with the umbrella. */
  protected savedWithCompanions = false;
  protected baseUnitPrice = 0;
  protected coverUnitPrice = 0;
  /** Resolved from a shared design's codes; seeds the card. */
  protected basePreselect: BaseSelection | null = null;
  /**
   * Share-code add only: the design as it arrived — the umbrella, its base
   * and its top cover, as design keys. Stamped on every line the add creates,
   * which are then judged against it, now and on every later edit.
   */
  private sharedOrigin: SharedDesignOrigin | null = null;
  /**
   * FUPOF-193, setup editor: the setup's base line as it stood when this page
   * opened from the cart, or null when the setup had none. Drives the Base
   * card's lead-in note and the footer label only — the save never writes
   * through it, and finds every member afresh by setup id (see
   * buildSetupItems).
   */
  protected loadedBaseMember: LineItem | null = null;
  /** Whether that base had its top cover beside it. */
  protected loadedHasCover = false;
  /**
   * The selection the card was seeded with, split into the base line's part and
   * the cover line's part, so an unchanged half is never rebuilt — and never
   * re-priced over a price the rep accepted from NetSuite.
   */
  private loadedBaseKey: string | null = null;
  private loadedCoverKey: string | null = null;
  /**
   * Set while the card is still applying the seeded base (catalog fetch, then
   * pricing). Until it settles `baseSelection` is null for reasons that have
   * nothing to do with the rep, so a save in that window must read "untouched",
   * never "No Base" — which would delete the base line.
   */
  private awaitingBaseSettle = false;
  /**
   * The setup's base could not be shown on the card (discontinued, or no
   * longer offered for this umbrella). The line stays on the quote until the
   * rep explicitly picks No Base.
   */
  protected baseMemberUnresolved = false;
  /** Filled by the same /products/sku call that returns the umbrella SKU. */
  protected baseSku = "";
  /**
   * FUPOF-193: price and SKU requests still out. Each is counted up before
   * its request and down in a `finally`, so a failed call can never leave the
   * footer disabled. See pricingBusy.
   */
  private pendingRequests = 0;
  /** Latest price / SKU request; a reply from an earlier one is discarded. */
  private priceRequestSeq = 0;
  private skuRequestSeq = 0;
  /**
   * The latest SKU request failed, so the SKUs on hand belong to an earlier
   * configuration. Holds the footer until a later request succeeds — which
   * any change to the configuration makes.
   *
   * Blocking is the only safe answer here. Keeping the previous SKU would save
   * the wrong NetSuite item beside the new model, and clearing it would save
   * an empty SKU: nothing downstream rejects one.
   */
  private skuFailed = false;
  /** The Base card is still pricing (or debouncing) the rep's last change. */
  private baseCardBusy = false;
  /** From the product line; picks the card's catalog strategy. */
  protected specificMounting = false;
  /**
   * FUPOF-193: the configuration as it stood when this design was loaded.
   * Compared at save time to decide whether the provenance pill is still
   * truthful — see captureSharedBaseline.
   */
  protected sharedConfigFingerprint: string | null = null;
  /**
   * FUPOF-193: the deviation warning. The first change that takes a design
   * away from its code asks before it stands (ConfirmDesignDeviation).
   */
  protected showDeviationModal = false;
  /**
   * The rep has already agreed to leave the design — by answering Continue, or
   * because the page opened on a design that was adjusted already. Dropped the
   * moment the configuration is back on the design, so the next change away
   * from it asks again.
   */
  private deviationAcknowledged = false;
  /** Raised once loading has settled; nothing before that is the rep's. */
  private deviationGuardArmed = false;
  /** Cancel is putting the design back; those writes are not a deviation. */
  private revertingDeviation = false;
  /**
   * A seeded base the card has not settled yet (a code's base, or one put
   * back by Cancel). Until it does `baseSelection` lags the card, so the base
   * is left out of the comparison.
   */
  private designBasePending = false;
  /**
   * The page as it last stood on the design, which is what Cancel restores.
   * Refreshed whenever the configuration is on the design, so it is always
   * the state just before the change being asked about.
   */
  private designSnapshot: {
    model: string;
    details: string;
    isStockOnly: boolean;
    base: BaseSelection | null;
    baseUnresolved: boolean;
  } | null = null;
  protected defaultConfigFile: null | ConfigFile = null;
  /**
   * Captured from the collection at `created()` time. Used by the trim
   * dimension getters (4"/6"/2"/4") since dimensions differ between
   * Market and Cantilever umbrellas. Mirrors shade-designer's
   * isMarketType pattern.
   */
  protected umbrellaType: UmbrellaType | null = null;
  /**
   * Cached WHP swatch — used as the default for valance binding and
   * the first fringe fabric. Fetched once at `created()` time so we
   * don't re-hit the API on every valance/fringe toggle.
   */
  protected whpFabric: FabricSwatch | null = null;
  protected whpPromise: Promise<FabricSwatch> | null = null;
  /**
   * Cached weight-keyed white fabric — used as the default for trim
   * fabrics (mainTrimFabric + mainTrimFabricInner) when the user
   * switches into a trim layout. Mirrors shade-designer's
   * setWhiteFabric() logic: 8oz canopies use 57003-0000, 9oz canopies
   * use R-099. Each weight is fetched once and reused for the lifetime
   * of the component instance.
   */
  protected whiteFabricByWeight: Record<string, FabricSwatch> = {};
  protected whiteFabricPromiseByWeight: Record<
    string,
    Promise<FabricSwatch>
  > = {};
  protected NoteFields = NoteFields;
  protected getFinishImage = getFinishImage;
  protected ProductLineName = ProductLineName;
  protected selected: UmbrellaModel | null = null;
  protected index: null | number = 0;
  protected ProductType = ProductType;
  protected displayName = "";
  protected model = "";
  protected option = option;
  protected swatch: FabricSwatch | null = null;
  protected ribAttachment = ribAttachment;
  protected hasFinial = hasFinial;
  protected hasBottomPole = hasBottomPole;
  protected productService = new ProductService();
  protected itemPrice = 0;
  protected FabricComponent = FabricComponent;
  protected component: FabricComponent | null = null;
  protected fabricSelectorVisible = false;
  protected ventTopFabricManuallySet = false;
  private syncingVentFabric = false;
  // Mirrors the top-vent sync pattern for the alternating-panel arrays
  // (double-vent middle and valance): mainFabric → arr stays in sync until
  // the user picks a fabric for one of those slots that diverges from the
  // corresponding mainFabric panel. Once flagged manual, the sync stops.
  protected ventMiddleFabricManuallySet = false;
  private syncingVentMiddleFabric = false;
  protected valanceFabricManuallySet = false;
  private syncingValanceFabric = false;
  /**
   * True while applyStoredItem is loading a stored line (a cart edit, or a
   * Shade Designer code), through the watcher flush its writes trigger.
   * Loading changes what the layout and valance watchers watch — Single to
   * Double, "none" to a valance style — and without this they read it as the
   * rep switching, and re-seed the double-vent and valance fabrics from main
   * over the ones just loaded (KNP9X lost both; see applyStoredItem).
   */
  private hydrating = false;
  private ribAutoSwitchedToGrommets = false;
  private ribBeforeAutoSwitch: option.Rib | null = null;
  private suppressRibWatch = false;
  private lastMainFabricCodes: string[] = [];
  // Previous panel-array lengths, captured so the 2→3 mirror watchers can
  // distinguish growth (auto-mirror to 4) from shrinkage (leave at 3 and
  // let the UI show the missing-fabric warning).
  private lastMainFabricLength = 0;
  private lastVentMiddleFabricLength = 0;
  private lastValanceFabricLength = 0;
  protected loader: any = null;
  protected finishDisplayName = FinishDisplayName;
  protected showSpecsModal = false;
  /**
   * Vent selection (Single Vent / Double Vent). After the trim decoupling
   * (Phase 5), `layoutName` is **vent-only** — it no longer holds
   * D1/D2/D3 values. Trim is tracked separately in `selectedTrimOption`.
   */
  protected layoutName:
    | option.StandardLayoutNames
    | option.PresetDesignerNames = option.StandardLayoutNames.Single;
  /**
   * Trim selection — independent of vent. Mirrors shade-designer's
   * `selectedTrimOption`. Possible values:
   *   - "none"   → No Trim (preset = S1 or S1DV depending on vent)
   *   - "single" → Single Trim (preset = D1)
   *   - "double" → Double Trim (preset = D2)
   *   - "triple" → Triple Trim (preset = D3)
   * Trim takes precedence: when trim is active, preset is locked to D1/D2/D3
   * regardless of vent choice; vent only drives the preset when trim is none.
   */
  protected selectedTrimOption: "none" | "single" | "double" | "triple" =
    "none";
  protected designerLayoutName: option.PresetDesignerNames =
    option.PresetDesignerNames.None;
  protected sku = "";
  protected item_details: CustomUmbrellaOrder = {
    canopy: {
      mainCanopy: option.Panel.Solid,
      ventMiddle: null,
      mainFabric: [],
      mainTrimFabric: null,
      mainTrimFabricInner: null,
      ventTopFabric: [],
      ventMiddleFabric: [],
      ventTrimFabric: null,
      valance: option.Valance.Canopy,
      valanceFabric: [],
      fringe: option.Fringe.None,
      fringeFabric: [],
      bindingFabric: null,
      rib: null,
      ribFabric: null,
      undersideFabric: null
    },
    frame: {
      finish: null!,
      finial: null!,
      finialFinish: null,
      bottomPole: option.BottomPole.Standard,
      spigot: null
    },
    layout: {
      productline: {
        handle: this.handle
      },
      preset: option.Preset.S1
    },
    notes: []
  };
  protected noteObj = {
    model: "",
    canopy: "",
    frame: "",
    valance: "",
    fringe: "",
    bottomPole: "",
    finial: "",
    rib: "",
    spigot: ""
  };
  protected showNoteModal = {
    model: false,
    canopy: false,
    frame: false,
    valance: false,
    fringe: false,
    bottomPole: false,
    finial: false,
    rib: false,
    spigot: false
  };
  protected formatTitle = formatTitle;

  /** ALl custom validations should evaluate to true to submit form. Invalid = false */
  @Validations()
  validations() {
    return {
      model: { required },
      item_details: {
        canopy: {
          mainFabric: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(this.maxFabricsAllowed),
            arrayLenEven
          },
          mainTrimFabric: {
            required: requiredIf(
              () => this.selectedTrimOption !== "none"
            ),
            minLength: minLength(1)
          },
          mainTrimFabricInner: {
            required: requiredIf(
              () =>
                this.selectedTrimOption === "double" ||
                this.selectedTrimOption === "triple"
            ),
            minLength: minLength(1)
          },
          ventTopFabric: {
            required: requiredIf(() => this.selected?.attributes.vent),
            minLength: minLength(1),
            maxLength: maxLength(this.maxFabricsAllowed),
            arrayLenEven
          },
          ventMiddleFabric: {
            required: requiredIf(
              () => this.layoutName === option.StandardLayoutNames.Double
            ),
            minLength: minLength(1),
            maxLength: maxLength(this.maxFabricsAllowed),
            arrayLenEven
          },
          valance: {
            required: requiredIf(() => this.selected?.attributes.valance)
          },
          valanceFabric: {
            required: requiredIf(
              () => this.item_details?.canopy.valance !== option.Valance.Canopy
            ),
            minLength: minLength(1),
            maxLength: maxLength(this.maxFabricsAllowed),
            arrayLenEven
          },
          fringe: {},
          fringeFabric: {
            required: requiredIf(
              () =>
                this.fringeFabricsReady &&
                this.item_details?.canopy.fringe !== option.Fringe.None
            ),
            minLength: minLength(1),
            maxLength: maxLength(3)
          },
          // ribFabric: {
          //   required: requiredIf(
          //     () => this.item_details.canopy.rib === option.Rib.Pockets
          //   ),
          //   minLength: minLength(1),
          // },
          rib: {
            required: requiredIf(
              () =>
                this.isGrommetOnlyModel ||
                ribAttachment.grommets.includes(this.handle) ||
                ribAttachment.pockets.includes(this.handle)
            )
          }
        },
        frame: {
          finish: { required },
          finial: {
            required: requiredIf(() => this.hasFinial.includes(this.handle))
          }
        }
      }
    };
  }

  @Watch("designDeviates")
  private onDesignDeviatesChange(deviates: boolean | null): void {
    if (!this.deviationGuardArmed || this.revertingDeviation) return;
    if (deviates === false) {
      this.settleDeviationGuard();
    } else if (deviates && !this.deviationAcknowledged) {
      this.showDeviationModal = true;
    }
  }

  @Watch("model")
  private async onModelChange(): Promise<void> {
    await this.updatePriceAndSKU();
  }

  @Watch("layoutName")
  private async onLayoutNameChange(
    val: option.PresetDesignerNames | option.StandardLayoutNames,
    oldVal: option.PresetDesignerNames | option.StandardLayoutNames
  ): Promise<void> {
    // After the Phase 5 trim decoupling, layoutName is vent-only.
    // Trim is handled independently in `onTrimOptionChange`. This
    // watcher therefore only manages vent state and the preset's
    // vent component (S1 ↔ S1DV when trim is none).
    switch (val) {
      case option.StandardLayoutNames.Single:
        this.item_details.layout.preset = this.computePreset();
        // Reset Double Vent properties when switching to Single Vent.
        this.item_details.canopy.ventMiddle = null;
        this.item_details.canopy.ventMiddleFabric = [];
        await this.updatePriceAndSKU();
        break;

      case option.StandardLayoutNames.Double:
        this.item_details.layout.preset = this.computePreset();
        // Underside and double vent are mutually exclusive; clear
        // underside when enabling double vent.
        this.item_details.canopy.undersideFabric = null;
        // Seed the double-vent fabric array from the current main canopy
        // panels and start in sync mode. The user can later pick a fabric
        // for any double-vent slot — that flips ventMiddleFabricManuallySet
        // and the array stops mirroring main canopy changes.
        //
        // Not while a stored line is loading with its own double-vent fabrics:
        // those are the line's, not a default. A legacy line with none is
        // still seeded.
        if (
          this.hydrating &&
          this.item_details.canopy.ventMiddleFabric.length > 0
        ) {
          await this.updatePriceAndSKU();
          break;
        }
        this.ventMiddleFabricManuallySet = false;
        if (this.item_details.canopy.mainFabric.length > 0) {
          this.syncingVentMiddleFabric = true;
          (this.item_details.canopy.ventMiddleFabric as FabricSwatch[]) = [
            ...(this.item_details.canopy.mainFabric as FabricSwatch[])
          ];
          this.$nextTick(() => {
            this.syncingVentMiddleFabric = false;
          });
        }
        await this.updatePriceAndSKU();
        break;

      default:
        // Stale designer-preset value slipping through after the trim
        // decoupling — coerce back to a safe vent value. This branch
        // should be unreachable in normal flow.
        this.layoutName =
          oldVal === option.StandardLayoutNames.Single ||
          oldVal === option.StandardLayoutNames.Double
            ? oldVal
            : option.StandardLayoutNames.Single;
        break;
    }
  }

  /**
   * Compute the canopy preset from the current vent + trim selections.
   * Trim takes precedence (D1/D2/D3 are locked by trim regardless of
   * vent state); when trim is "none", the preset is driven by vent
   * (Single → S1, Double → S1DV). Mirrors shade-designer's
   * `trimOptionToPreset` logic.
   */
  protected computePreset(): option.Preset {
    switch (this.selectedTrimOption) {
      case "single":
        return option.Preset.D1;
      case "double":
        return option.Preset.D2;
      case "triple":
        return option.Preset.D3;
      default:
        return this.layoutName === option.StandardLayoutNames.Double
          ? option.Preset.S1DV
          : option.Preset.S1;
    }
  }

  /**
   * Initialize `selectedTrimOption` from a stored canopy preset (used
   * on edit-mode hydration). S1/S1DV → none; D1 → single; D2 → double;
   * D3 → triple; anything else (D4/D5) → none.
   */
  protected presetToTrimOption(
    preset: option.Preset
  ): "none" | "single" | "double" | "triple" {
    switch (preset) {
      case option.Preset.D1:
        return "single";
      case option.Preset.D2:
        return "double";
      case option.Preset.D3:
        return "triple";
      default:
        return "none";
    }
  }

  /**
   * Trim selection watcher — independent of vent. When the user picks
   * a trim option, this seeds (or clears) the trim fabric slots and
   * recomputes the canopy preset. Vent state is left untouched.
   */
  @Watch("selectedTrimOption")
  private async onTrimOptionChange(
    val: "none" | "single" | "double" | "triple"
  ): Promise<void> {
    switch (val) {
      case "single": {
        // Single Trim seeds the outer trim with the canopy-weight white
        // default; inner trim is cleared (only outer applies to D1).
        this.item_details.canopy.mainTrimFabricInner = null;
        if (!this.item_details.canopy.mainTrimFabric) {
          const white = await this.getWhiteTrimFabric(this.canopyWeight);
          if (white) this.item_details.canopy.mainTrimFabric = white;
        }
        break;
      }
      case "double":
      case "triple": {
        // Double / Triple Trim: seed both outer and inner trim with the
        // weight-appropriate white default when either slot is empty.
        const white = await this.getWhiteTrimFabric(this.canopyWeight);
        if (white) {
          if (!this.item_details.canopy.mainTrimFabric) {
            this.item_details.canopy.mainTrimFabric = white;
          }
          if (!this.item_details.canopy.mainTrimFabricInner) {
            this.item_details.canopy.mainTrimFabricInner = white;
          }
        }
        break;
      }
      case "none":
      default: {
        // No Trim — clear both trim fabric slots.
        this.item_details.canopy.mainTrimFabric = null;
        this.item_details.canopy.mainTrimFabricInner = null;
        break;
      }
    }
    this.item_details.layout.preset = this.computePreset();
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.mainFabric")
  private async mainFabricChange(): Promise<void> {
    // 2→3 panel transition (growth only): auto-mirror the 2nd fabric into
    // the 4th slot so the alternating pattern is ABAB. Shrinking from 4→3
    // leaves the array at 3 so the UI can prompt the user to fill the
    // missing panel rather than silently re-filling it.
    const mainFabricArr = this.item_details.canopy.mainFabric as FabricSwatch[];
    const grewToThree =
      mainFabricArr.length === 3 && this.lastMainFabricLength === 2;
    this.lastMainFabricLength = mainFabricArr.length;
    if (grewToThree) {
      (this.item_details.canopy
        .mainFabric as FabricSwatch[]) = this.mirrorAlternatingPattern(
        mainFabricArr
      );
      return;
    }
    const mainFabric = this.item_details.canopy.mainFabric[0];
    const ventTopFabric = this.item_details.canopy.ventTopFabric[0];
    const ventMiddleFabric = this.item_details.canopy.ventMiddleFabric[0];
    const valanceFabric = this.item_details.canopy.valanceFabric[0];

    // Check if mainFabric actually changed (not just a reference change from canopy object replacement)
    const currentCodes = (this.item_details.canopy
      .mainFabric as FabricSwatch[]).map(f => f.mfr_code);
    const mainFabricActuallyChanged =
      currentCodes.length !== this.lastMainFabricCodes.length ||
      currentCodes.some(
        (code: string, i: number) => code !== this.lastMainFabricCodes[i]
      );
    this.lastMainFabricCodes = currentCodes;

    if (!mainFabricActuallyChanged) {
      return;
    }

    if (mainFabric) {
      if (
        !this.ventTopFabricManuallySet ||
        (ventTopFabric &&
          ventTopFabric.weight !== mainFabric.weight)
      ) {
        this.syncingVentFabric = true;
        (this.item_details.canopy.ventTopFabric as FabricSwatch[]) = [
          mainFabric
        ];
        this.$nextTick(() => { this.syncingVentFabric = false; });
      }
      // Double-vent middle: mirror the entire mainFabric array as long
      // as the user hasn't manually customized any double-vent slot.
      // Weight-mismatch is a hard correctness rule and forces re-sync
      // even after manual changes, matching the previous behavior.
      if (this.item_details.canopy.ventMiddleFabric.length > 0) {
        const weightMismatch =
          ventMiddleFabric && ventMiddleFabric.weight !== mainFabric.weight;
        if (!this.ventMiddleFabricManuallySet || weightMismatch) {
          this.syncingVentMiddleFabric = true;
          (this.item_details.canopy.ventMiddleFabric as FabricSwatch[]) = [
            ...(this.item_details.canopy.mainFabric as FabricSwatch[])
          ];
          if (weightMismatch) this.ventMiddleFabricManuallySet = false;
          this.$nextTick(() => {
            this.syncingVentMiddleFabric = false;
          });
        }
      }
      // Valance: same sync pattern as double-vent middle.
      if (this.item_details.canopy.valanceFabric.length > 0) {
        const weightMismatch =
          valanceFabric && valanceFabric.weight !== mainFabric.weight;
        if (!this.valanceFabricManuallySet || weightMismatch) {
          this.syncingValanceFabric = true;
          (this.item_details.canopy.valanceFabric as FabricSwatch[]) = [
            ...(this.item_details.canopy.mainFabric as FabricSwatch[])
          ];
          if (weightMismatch) this.valanceFabricManuallySet = false;
          this.$nextTick(() => {
            this.syncingValanceFabric = false;
          });
        }
      }
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.ventMiddleFabric")
  private onVentMiddleFabricChange(): void {
    const arr = this.item_details.canopy.ventMiddleFabric as FabricSwatch[];
    const grewToThree =
      arr.length === 3 && this.lastVentMiddleFabricLength === 2;
    this.lastVentMiddleFabricLength = arr.length;
    if (grewToThree) {
      (this.item_details.canopy
        .ventMiddleFabric as FabricSwatch[]) = this.mirrorAlternatingPattern(
        arr
      );
      return;
    }
    // Detect manual customization: if any slot in ventMiddleFabric
    // diverges from the corresponding mainFabric slot, flag it manual
    // so future mainFabric changes stop overwriting these selections.
    if (this.syncingVentMiddleFabric || this.isStockOnly) return;
    if (this.divergesFromMain(arr)) {
      this.ventMiddleFabricManuallySet = true;
    }
  }

  @Watch("item_details.canopy.valanceFabric")
  private onValanceFabricChange(): void {
    const arr = this.item_details.canopy.valanceFabric as FabricSwatch[];
    const grewToThree =
      arr.length === 3 && this.lastValanceFabricLength === 2;
    this.lastValanceFabricLength = arr.length;
    if (grewToThree) {
      (this.item_details.canopy
        .valanceFabric as FabricSwatch[]) = this.mirrorAlternatingPattern(arr);
      return;
    }
    if (this.syncingValanceFabric || this.isStockOnly) return;
    if (this.divergesFromMain(arr)) {
      this.valanceFabricManuallySet = true;
    }
  }

  /**
   * Per-slot divergence check against the main canopy panels — true if
   * any slot in `arr` has a different fabric mfr_code from the same
   * slot in mainFabric (or if a slot exists in `arr` past the end of
   * mainFabric). Used to flip the manuallySet flags for double-vent
   * middle and valance arrays.
   */
  protected divergesFromMain(arr: readonly FabricSwatch[]): boolean {
    const main = this.item_details.canopy.mainFabric as FabricSwatch[];
    if (arr.length === 0) return false;
    return arr.some((f, i) => {
      const correspondingMain = main[i];
      return !correspondingMain || f.mfr_code !== correspondingMain.mfr_code;
    });
  }

  @Watch("item_details.canopy.ventTopFabric")
  private async onVentTopFabricChange(): Promise<void> {
    if (this.syncingVentFabric || this.isStockOnly) return;
    const mainFabric = this.item_details.canopy.mainFabric[0];
    const ventTopFabric = this.item_details.canopy.ventTopFabric[0];
    if (mainFabric && ventTopFabric) {
      this.ventTopFabricManuallySet =
        ventTopFabric.mfr_code !== mainFabric.mfr_code;
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.mainTrimFabric")
  private async handleSingleTrimFabricSelection(): Promise<void> {
    if (
      this.item_details.canopy.mainTrimFabric !== null &&
      this.item_details.canopy.mainTrimFabricInner === null &&
      this.item_details.layout.preset === option.Preset.D1
    ) {
      await this.updatePriceAndSKU();
    }
  }

  @Watch("item_details.canopy.mainTrimFabricInner")
  private async handleDoubleOrTripleTrimFabricSelection(): Promise<void> {
    if (
      this.item_details.canopy.mainTrimFabricInner !== null &&
      this.item_details.canopy.mainTrimFabric !== null &&
      (this.item_details.layout.preset === option.Preset.D2 ||
        this.item_details.layout.preset === option.Preset.D3)
    ) {
      await this.updatePriceAndSKU();
    }
  }

  @Watch("item_details.canopy.valance")
  private async setBindingFabric(): Promise<void> {
    if (this.item_details.canopy.valance !== option.Valance.Canopy) {
      // Seed from main canopy fabrics and start in sync mode. The user
      // can later pick a fabric for any valance slot — that flips
      // valanceFabricManuallySet and the array stops mirroring main.
      //
      // Not while a stored line is loading with its own valance fabrics (see
      // `hydrating`). Read before the first await below, so it is read inside
      // the flush the load triggered. A legacy line with none is still seeded,
      // and a rep changing the style re-seeds exactly as before.
      const keepLoaded =
        this.hydrating && this.item_details.canopy.valanceFabric.length > 0;
      if (!keepLoaded) this.valanceFabricManuallySet = false;
      if (!keepLoaded && this.item_details.canopy.mainFabric.length > 0) {
        this.syncingValanceFabric = true;
        this.item_details.canopy.valanceFabric = (this.item_details.canopy.mainFabric.filter(
          (f): f is FabricSwatch => !!f
        ) as unknown) as FixedFabricArray;
        this.$nextTick(() => {
          this.syncingValanceFabric = false;
        });
      }

      this.item_details.canopy.bindingFabric = this.item_details.canopy
        .bindingFabric
        ? this.item_details.canopy.bindingFabric
        : await this.getWhp();
    } else {
      this.item_details.canopy.bindingFabric = null;
      this.item_details.canopy.valanceFabric = [];
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.fringe")
  private async onFringeChange(): Promise<void> {
    if (this.item_details.canopy.fringe === option.Fringe.None) {
      this.item_details.canopy.fringeFabric = [];
    } else {
      // Default the first fringe fabric to WHP when none is set yet,
      // mirroring the valance-binding default behavior.
      if (this.item_details.canopy.fringeFabric.length === 0) {
        const defaultFringe = await this.getWhp();
        if (defaultFringe) {
          this.item_details.canopy.fringeFabric = ([
            defaultFringe
          ] as unknown) as FixedFabricArray;
        }
      } else if (
        this.item_details.canopy.fringeFabric.length > this.maxFringeFabrics
      ) {
        this.item_details.canopy.fringeFabric.splice(this.maxFringeFabrics);
      }
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.rib")
  private async onRibChange(): Promise<void> {
    if (this.item_details.canopy.rib === option.Rib.Grommets) {
      this.item_details.canopy.ribFabric = null;
    }
    // If this change was from the user (not programmatic), clear auto-switch tracking
    if (!this.suppressRibWatch && this.ribAutoSwitchedToGrommets) {
      this.ribAutoSwitchedToGrommets = false;
      this.ribBeforeAutoSwitch = null;
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.frame.finish")
  private async onFinishChange(): Promise<void> {
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.frame.finialFinish")
  private async onFinialFinishChange(): Promise<void> {
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.frame.bottomPole")
  private async onBottomPoleChange(): Promise<void> {
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.frame.spigot")
  private async onSpigotChange(): Promise<void> {
    if (this.item_details.frame.spigot != null) {
      this.item_details.frame.bottomPole = null;
    }
    await this.updatePriceAndSKU();
  }

  protected readonly maxFabricsAllowed = 4;

  get availableValanceOptions(): option.Valance[] {
    // Filter out VintageScallop until SVG is available
    return Object.values(option.Valance).filter(
      v => v !== option.Valance.VintageScallop
    );
  }

  get isGrommetOnlyModel(): boolean {
    return !!this.selected && grommetOnlyModels.includes(this.selected.model);
  }

  get grommetText(): string {
    if (
      this.isGrommetOnlyModel ||
      this.handle === ProductLineName.Greenwich ||
      this.handle === ProductLineName.GreenwichGSeries ||
      this.handle === ProductLineName.MontereyGSeries ||
      this.handle === ProductLineName.Eclipse ||
      this.handle === ProductLineName.Aurora
    ) {
      return "STANDARD";
    } else {
      return "OPTION";
    }
  }

  get pocketText(): string {
    if (this.isGrommetOnlyModel) {
      return "OPTION";
    }
    if (
      this.handle !== ProductLineName.Greenwich &&
      this.handle !== ProductLineName.GreenwichGSeries &&
      this.handle !== ProductLineName.MontereyGSeries &&
      this.handle !== ProductLineName.Eclipse &&
      this.handle !== ProductLineName.Aurora
    ) {
      return "STANDARD";
    } else {
      return "OPTION";
    }
  }

  get presetDesignerNames(): string[] {
    return Object.values(option.PresetDesignerNames).filter(
      value => value !== option.PresetDesignerNames.None
    );
  }

  /** Trim options shown after the "No Trim" button in the new
   *  Phase 5 trim radio row. The "none" value is rendered separately. */
  get trimOptions(): { value: "single" | "double" | "triple"; label: string }[] {
    return [
      { value: "single", label: "Single Trim" },
      { value: "double", label: "Double Trim" },
      { value: "triple", label: "Triple Trim" }
    ];
  }

  /** True for market-type umbrellas (excluding 882FMC-R, which behaves
   *  like a cantilever for trim sizing). Mirrors shade-designer. */
  get isMarketTrimSizing(): boolean {
    return (
      this.umbrellaType === UmbrellaType.Market &&
      this.selected?.model !== "882FMC-R"
    );
  }

  /**
   * Trim dimension labels shown beneath each trim swatch. Sizes differ
   * between market and non-market umbrellas. Mirrors shade-designer's
   * outerTrimDimension / canopyTrimDimension / innerTrimDimension.
   */
  get outerTrimDimension(): string {
    if (this.selectedTrimOption === "none") return "";
    return '4"';
  }

  get canopyTrimDimension(): string {
    if (this.selectedTrimOption === "double") {
      return '2"';
    }
    if (this.selectedTrimOption === "triple") {
      return '4"';
    }
    return "";
  }

  get innerTrimDimension(): string {
    if (this.selectedTrimOption === "double") {
      return '2"';
    }
    if (this.selectedTrimOption === "triple") {
      return '4"';
    }
    return "";
  }

  get hasCanopyFabricOptions(): boolean {
    if (
      this.handle === ProductLineName.Eclipse ||
      this.handle === ProductLineName.Aurora ||
      this.handle === ProductLineName.Nova ||
      this.handle === ProductLineName.GreenwichGSeries ||
      this.handle === ProductLineName.MontereyGSeries ||
      this.handle === ProductLineName.Greenwich ||
      this.handle === ProductLineName.MontereyPulleyLift ||
      this.handle === ProductLineName.MontereyCrank ||
      this.handle === ProductLineName.MontereyAutoTilt
    ) {
      return true;
    }
    return false;
  }

  /**
   * Show the Canopy "Vent" row only when there is something to render:
   * the product line offers canopy fabric choices, the line has a vent
   * option, or a double-vent layout is active. Prevents an empty label
   * shell on lines with no vent (e.g. Avalon).
   */
  get showVentRow(): boolean {
    return (
      this.hasCanopyFabricOptions ||
      !!this.selected?.attributes.vent ||
      this.layoutName === option.StandardLayoutNames.Double
    );
  }

  /**
   * Show the Canopy "Trim" row only when the product line offers canopy
   * fabric choices or a trim option is currently selected.
   */
  get showTrimRow(): boolean {
    return this.hasCanopyFabricOptions || this.selectedTrimOption !== "none";
  }

  // Finial logic computed properties
  get isGreenwichCollection(): boolean {
    return (
      this.handle === ProductLineName.Greenwich ||
      this.handle === ProductLineName.GreenwichGSeries
    );
  }

  get isMontereyCollection(): boolean {
    return (
      this.handle === ProductLineName.MontereyPulleyLift ||
      this.handle === ProductLineName.MontereyAutoTilt ||
      this.handle === ProductLineName.MontereyCrank ||
      this.handle === ProductLineName.MontereyGSeries
    );
  }

  get finialDefaultType(): string {
    // Greenwich defaults to Vertex, Monterey defaults to Ball
    return this.isGreenwichCollection
      ? option.Finial.Vertex
      : option.Finial.Ball;
  }

  get finialOptionType(): string {
    // Greenwich has Ball as option, Monterey has Vertex as option
    return this.isGreenwichCollection
      ? option.Finial.Ball
      : option.Finial.Vertex;
  }

  get finialDefaultLabel(): string {
    return this.isGreenwichCollection ? "Vertex" : "Classic Ball";
  }

  get finialOptionLabel(): string {
    return this.isGreenwichCollection ? "Classic Ball" : "Vertex";
  }

  get hasFinialFinishNote(): boolean {
    if (this.handle === ProductLineName.Eclipse) return false;
    const finish = this.item_details.frame.finialFinish;
    if (finish === option.FinialFinishType.SS) return true;
    const montereyMarket: ProductLineName[] = [
      ProductLineName.MontereyPulleyLift,
      ProductLineName.MontereyAutoTilt,
      ProductLineName.MontereyCrank
    ];
    if (montereyMarket.includes(this.handle)) {
      return finish === option.FinialFinishType.CH;
    }
    return false;
  }

  get finialFinishNote(): string {
    if (!this.hasFinialFinishNote) return "";
    if (this.item_details.frame.finialFinish === option.FinialFinishType.CH) {
      return "Chrome";
    }
    return "Stainless Steel Upgrade";
  }

  get isNonStandardRib(): boolean {
    if (!this.defaultConfigFile?.canopy?.rib) return false;
    return this.item_details.canopy.rib !== this.defaultConfigFile.canopy.rib;
  }

  get nonStandardRibNote(): string {
    if (!this.isNonStandardRib) return "";
    return this.item_details.canopy.rib === option.Rib.Grommets
      ? "Grommets"
      : "Pockets";
  }

  get isNonStandardBottomPole(): boolean {
    return this.item_details.frame.bottomPole === option.BottomPole.Bar;
  }

  get nonStandardBottomPoleNote(): string {
    if (!this.isNonStandardBottomPole) return "";
    return "Bar Height Bottom Pole upgrade.";
  }

  get isNonStandardFinial(): boolean {
    if (!this.hasFinial.includes(this.handle)) return false;
    return this.item_details.frame.finial !== this.finialDefaultType;
  }

  get nonStandardFinialNote(): string {
    if (!this.isNonStandardFinial) return "";
    return this.finialOptionLabel;
  }

  get hasTPUMatchFinish(): boolean {
    // TPU Match is available for Monterey (Pulley Lift, Crank, Auto Tilt) but NOT G-Series
    return (
      this.handle === ProductLineName.MontereyPulleyLift ||
      this.handle === ProductLineName.MontereyCrank ||
      this.handle === ProductLineName.MontereyAutoTilt
    );
  }

  /**
   * Returns the cached WHP swatch, fetching it once if not already
   * loaded. Concurrent callers share the same in-flight promise so we
   * never fire more than one network request for this default fabric.
   */
  protected async getWhp(): Promise<FabricSwatch> {
    if (this.whpFabric) return this.whpFabric;
    if (!this.whpPromise) {
      this.whpPromise = this.getFabricObject("WHP");
    }
    this.whpFabric = await this.whpPromise;
    return this.whpFabric;
  }

  /**
   * Returns the canopy-weight-appropriate white trim fabric, fetching
   * and caching it on first request. Mirrors shade-designer's
   * setWhiteFabric(): 8oz → 57003-0000, 9oz → R-099. Returns null for
   * any other weight (callers should skip seeding in that case).
   */
  protected async getWhiteTrimFabric(
    weight: string
  ): Promise<FabricSwatch | null> {
    const mfrCodeByWeight: Record<string, string> = {
      "8": "57003-0000",
      "9": "R-099"
    };
    const mfrCode = mfrCodeByWeight[weight];
    if (!mfrCode) return null;
    if (this.whiteFabricByWeight[weight]) {
      return this.whiteFabricByWeight[weight];
    }
    if (!this.whiteFabricPromiseByWeight[weight]) {
      this.whiteFabricPromiseByWeight[weight] = this.getFabricObject(mfrCode);
    }
    this.whiteFabricByWeight[weight] = await this.whiteFabricPromiseByWeight[
      weight
    ];
    return this.whiteFabricByWeight[weight];
  }

  /** Resolves the current canopy fabric's weight, defaulting to "9" if
   *  none is set yet — matches how filterMainFabricWeight defaults. */
  protected get canopyWeight(): string {
    const w = this.item_details.canopy.mainFabric[0]?.weight;
    return w || "9";
  }

  /**
   * Repeating-pattern panel arrays (main canopy, double vent middle,
   * valance) jump from 3 panels back up to 4 by mirroring the 2nd
   * panel into the 4th slot — i.e. an ABAB alternating pattern.
   * Returns the mirrored array when input length is exactly 3, or the
   * input array unchanged otherwise. Returns a new array reference so
   * Vue reactivity picks up the change.
   */
  protected mirrorAlternatingPattern(
    arr: readonly FabricSwatch[]
  ): FabricSwatch[] {
    if (arr.length !== 3) return arr as FabricSwatch[];
    return [arr[0], arr[1], arr[2], arr[1]];
  }

  async created() {
    const shareCode = this.$route.query.share as string | undefined;
    this.showLoader(
      shareCode ? `Loading Shade Design ${shareCode}` : undefined
    );
    // Kick off the WHP fetch + both weight-keyed white trim fetches in
    // parallel with the other init work — these are the default fabrics
    // for valance binding, fringe, and the Single/Double/Triple Trim
    // layouts. Caching them up front means switching trim layouts later
    // doesn't trigger a fresh network round-trip.
    const defaultsKickoff = Promise.all([
      this.getWhp(),
      this.getWhiteTrimFabric("8"),
      this.getWhiteTrimFabric("9")
    ]);
    const defaults = await this.getProductLineInfo();
    this.displayName = defaults.display_name;
    this.defaultConfigFile = defaults.config_file_id! as ConfigFile;
    this.umbrellaType = defaults.umbrella_type ?? null;
    // Picks which catalog the base card reads. Compared to `true` rather than
    // tested for truthiness: the field is optional on Collection, and an
    // undefined must fall to the generic grouped catalog, not be treated as a
    // curated line with no bases.
    this.specificMounting = defaults.specific_mounting === true;
    // Ensure the default-fabric cache is primed before any code path that
    // may need it (the await is essentially free once resolved).
    await defaultsKickoff;
    if (!this.$route.params.edit && this.$route.query.cart) {
      // if a user refreshes or back buttons onto this page, redirect to expired notice. because we are using index to update item, the user must navigate directly from the cart, or we can't guarantee the index is correct
      this.$router.replace("/resubmit");
      this.closeLoader();
    } else if (this.$route.params.edit && this.$route.query.cart) {
      await this.getItems(this.product, this.handle);
      this.editMode = true;
      this.isStockOnly = false;
      const index = parseInt(this.$route.query.cart as string, 10);
      await this.prepDataForEdit(index);
      await this.captureSharedBaseline(this.storeItems[index]);
      await this.prepSetupForEdit(index);
    } else if (this.$route.query.share) {
      // FUPOF-193 — preload a shared Shade Designer design. Placed AFTER both
      // query.cart branches so an edit URL always wins if somehow both are set.
      await this.getItems(this.product, this.handle);
      this.editMode = false; // footer must read "Add to Quote", not "Update"
      this.isStockOnly = false; // a shared design is by definition custom
      await this.prepDataFromSharedConfig(this.$route.query.share as string);
    } else {
      await this.getItems(this.product, this.handle);
      await this.setDefaults();
      this.setBindingFabric();
      this.updatePriceAndSKU();
    }
    this.closeLoader();
    await this.$nextTick();
    this.deviationGuardArmed = true;
    this.settleDeviationGuard();
    // FUPOF-193: a setup's base or cover pencil opens its umbrella here with
    // `section=base`, so land on the card the rep was looking at. Through
    // JumpLinks rather than a scroll of our own, so the section is expanded
    // and the sticky-header offset is measured the one way it already is.
    if (this.editMode && this.$route.query.section === "base") {
      this.$nextTick(() => {
        const jumpLinks = this.$refs.jumpLinks as JumpLinks | undefined;
        if (jumpLinks) jumpLinks.goTo("section-base");
      });
    }
  }

  protected async toggleStock(): Promise<void> {
    this.isStockOnly = !this.isStockOnly;
    if (this.isStockOnly) {
      this.item_details.canopy.ventMiddle = null;
      this.item_details.canopy.ventMiddleFabric = [];
      this.item_details.canopy.mainTrimFabric = null;
      this.item_details.canopy.mainTrimFabricInner = null;
      this.layoutName = option.StandardLayoutNames.Single;
      this.selectedTrimOption = "none";

      this.ribAutoSwitchedToGrommets = false;
      this.ribBeforeAutoSwitch = null;
      if (this.isGrommetOnlyModel) {
        this.item_details.canopy.rib = option.Rib.Grommets;
        this.item_details.canopy.ribFabric = null;
      } else {
        this.item_details.canopy.rib = this.defaultConfigFile!.canopy!.rib;
      }
      if (
        this.handle === ProductLineName.Eclipse ||
        this.handle === ProductLineName.Greenwich ||
        this.handle === ProductLineName.GreenwichGSeries
      ) {
        this.item_details.frame.finial = option.Finial.Vertex;
      } else if (this.hasFinial.includes(this.handle)) {
        this.item_details.frame.finial = option.Finial.Ball;
      }
      // Reset finial finish to default when toggling to stock
      if (this.handle === ProductLineName.Eclipse) {
        this.item_details.frame.finialFinish = option.FinialFinishType.SS;
      } else if (this.hasTPUMatchFinish) {
        this.item_details.frame.finialFinish = option.FinialFinishType.TPU;
      } else {
        this.item_details.frame.finialFinish = option.FinialFinishType.CH;
      }
      this.item_details.frame.bottomPole = option.BottomPole.Standard;
      (this.item_details.canopy.valance = option.Valance.Canopy),
        (this.item_details.canopy.valanceFabric = []);
      (this.item_details.canopy.fringe = option.Fringe.None),
        (this.item_details.canopy.fringeFabric = []);
      this.item_details.canopy.mainFabric.splice(1);
      this.ventTopFabricManuallySet = false;
      this.syncingVentFabric = true;
      (this.item_details.canopy.ventTopFabric as FabricSwatch[]) = [
        ...this.item_details.canopy.mainFabric
      ];
      this.$nextTick(() => { this.syncingVentFabric = false; });
    }
  }

  get toggleImg(): string {
    if (!this.isStockOnly) {
      return require("../../assets/images/toggle-true.png");
    } else {
      return require("../../assets/images/toggle-false.png");
    }
  }

  protected closeSpecsModal(): void {
    this.showSpecsModal = false;
  }

  protected toggleSpecsModal(): void {
    this.showSpecsModal = true;
  }

  protected mobileSetFinish(handle: FinishHandle): void {
    this.item_details.frame.finish = handle;
  }

  protected async prepDataForEdit(index: number): Promise<void> {
    await this.applyStoredItem(
      JSON.parse(JSON.stringify(this.storeItems[index])) as LineItem
    );
  }

  /**
   * Hydrate the page from a stored line. Split out of prepDataForEdit
   * (FUPOF-193) because only its first statement was ever index-specific:
   * everything below turns a line's `item_details` — whose fabric slots may be
   * bare "<mfr_code>" / "<mfr_code>::<group>" references rather than swatches —
   * into the fully-resolved objects this template renders from. A shared Shade
   * Designer design arrives in exactly that reference form, so it reuses this
   * verbatim rather than duplicating 170 lines of hydration.
   *
   * @param storeItemCopy a *copy* — this mutates what it is given.
   */
  protected async applyStoredItem(storeItemCopy: LineItem): Promise<void> {
    try {
      const itemDetails = storeItemCopy.item_details as CustomUmbrellaOrder;

      const mainFabric = [] as FabricSwatch[];
      for (const swatch of itemDetails.canopy.mainFabric) {
        let fabric;
        if (!swatch.mfr_code) {
          fabric = await this.getFabricObject(swatch as any);
        } else {
          fabric = swatch;
        }
        mainFabric.push(fabric);
      }

      let mainTrimFabric: FabricSwatch | null = null;
      if (
        itemDetails.canopy.mainTrimFabric &&
        !itemDetails.canopy.mainTrimFabric.mfr_code
      ) {
        mainTrimFabric = await this.getFabricObject(
          itemDetails.canopy.mainTrimFabric as any
        );
      } else {
        mainTrimFabric = itemDetails.canopy.mainTrimFabric;
      }

      let mainTrimFabricInner: FabricSwatch | null = null;
      if (
        itemDetails.canopy.mainTrimFabricInner &&
        !itemDetails.canopy.mainTrimFabricInner.mfr_code
      ) {
        mainTrimFabricInner = await this.getFabricObject(
          itemDetails.canopy.mainTrimFabricInner as any
        );
      } else {
        mainTrimFabricInner = itemDetails.canopy.mainTrimFabricInner;
      }

      const ventTopFabric = [] as FabricSwatch[];
      for (const swatch of itemDetails.canopy.ventTopFabric) {
        let fabric;
        if (!swatch.mfr_code) {
          fabric = await this.getFabricObject(swatch as any);
        } else {
          fabric = swatch;
        }
        ventTopFabric.push(fabric);
      }

      const ventMiddleFabric = [] as FabricSwatch[];
      for (const swatch of itemDetails.canopy.ventMiddleFabric) {
        let fabric;
        if (!swatch.mfr_code) {
          fabric = await this.getFabricObject(swatch as any);
        } else {
          fabric = swatch;
        }
        ventMiddleFabric.push(fabric);
      }

      const startingLayout = this.defaultConfigFile
        ? this.defaultConfigFile.layout
        : ({} as ConfigFile["layout"]);
      if (startingLayout.collection) {
        delete startingLayout.collection;
      }
      if (!(mainTrimFabric || mainTrimFabricInner)) {
        if (ventTopFabric.length > 0 && ventMiddleFabric.length > 0) {
          startingLayout.preset = option.Preset.S1DV;
        } else if (ventTopFabric.length > 0) {
          startingLayout.preset = option.Preset.S1;
        }
      }

      const valanceFabric = [] as FabricSwatch[];
      if (itemDetails.canopy.valanceFabric.length > 0) {
        for (const swatch of itemDetails.canopy.valanceFabric) {
          let fabric;
          if (!swatch.mfr_code) {
            fabric = await this.getFabricObject(swatch as any);
          } else {
            fabric = swatch;
          }
          valanceFabric.push(fabric);
        }
      }

      const fringeFabric = [] as FabricSwatch[];
      if (
        itemDetails.canopy.fringeFabric &&
        itemDetails.canopy.fringeFabric.length > 0
      ) {
        for (const swatch of itemDetails.canopy.fringeFabric) {
          let fabric;
          if (!swatch.mfr_code) {
            fabric = await this.getFabricObject(swatch as any);
          } else {
            fabric = swatch;
          }
          fringeFabric.push(fabric);
        }
      }

      let ribFabric: FabricSwatch | null = null;
      if (itemDetails.canopy.rib === option.Rib.Pockets) {
        ribFabric = mainFabric[0];
      } else {
        ribFabric = null;
      }

      // A bare code reference is resolved to its swatch; an already-hydrated
      // swatch is kept — the same pattern as every fabric above. The keep
      // branch was missing, so any line saved by this app (whose binding is a
      // full swatch) lost it on reopen: bindingFabric came back null and the
      // SKU dropped its `BIND-…` segment on an Update that changed nothing.
      //
      // The valance watcher (setBindingFabric) was presumably meant to refill
      // it, but it only fires when the valance *changes*, so an edit that
      // leaves the valance alone never reaches it. It keeps an existing binding
      // and seeds WHP only when there is none, so the two do not fight.
      let bindingFabric: FabricSwatch | null = null;
      if (itemDetails.canopy.bindingFabric) {
        if (!itemDetails.canopy.bindingFabric.mfr_code) {
          bindingFabric = await this.getFabricObject(
            itemDetails.canopy.bindingFabric as any
          );
        } else {
          bindingFabric = itemDetails.canopy.bindingFabric;
        }
      }

      // The underside slot is resolved here for the same reason every other
      // fabric above is: a SKU-parsed line carries a bare code reference
      // ("R-102") rather than a swatch, and the template reads .image and
      // .name.display straight off it. Left unresolved the panel renders an
      // empty swatch for a fabric the line genuinely has. An already-hydrated
      // value is kept as-is rather than dropped.
      let undersideFabric: FabricSwatch | null = null;
      if (itemDetails.canopy.undersideFabric) {
        if (!itemDetails.canopy.undersideFabric.mfr_code) {
          undersideFabric = await this.getFabricObject(
            itemDetails.canopy.undersideFabric as any
          );
        } else {
          undersideFabric = itemDetails.canopy.undersideFabric;
        }
      }

      const foundItem = this.items.find(item => item.model === storeItemCopy.model);
      this.selected = foundItem ? foundItem : this.items[0];
      this.model = this.selected!.model;
      const storedFringe = itemDetails.canopy.fringe ?? option.Fringe.None;
      const canopy = Object.assign(
        {},
        {
          ...itemDetails.canopy
        },
        {
          mainFabric: mainFabric,
          mainTrimFabric: mainTrimFabric,
          mainTrimFabricInner: mainTrimFabricInner,
          ventTopFabric: ventTopFabric,
          ventMiddleFabric: ventMiddleFabric,
          valanceFabric: valanceFabric,
          fringeFabric: storedFringe === option.Fringe.None ? [] : fringeFabric,
          bindingFabric: bindingFabric,
          undersideFabric: undersideFabric,
          ribFabric: ribFabric,
          // BugHerd #4. "No fringe" is the string "none", not null — every
          // read of these is written against the sentinel: RadioButtonBox
          // lights a tile on `model === value`, and both fabric pickers gate
          // on `!== None`. A stored document carrying null therefore leaves
          // all four tiles dark AND opens the fabric picker, and the fringe
          // watcher reads the same null as "a fringe is selected" and seeds a
          // WHP swatch that follows the line into the order.
          //
          // JRODK is a live example; the Eclipse default config file has
          // "none" for the same field, so stored documents are mixed and the
          // client cannot assume the sentinel. Normalized here rather than in
          // prepDataFromSharedConfig because the cart-edit path funnels
          // through here too, so lines already saved with null are repaired
          // when reopened.
          //
          // fringeFabric is cleared explicitly rather than left to the
          // watcher: once fringe is normalized it equals the initializer, so
          // the watcher never fires and an already-seeded swatch would
          // survive, invisible behind a hidden picker.
          //
          // frame.bottomPole is deliberately NOT coalesced the same way —
          // null is meaningful there, set by the spigot watcher.
          fringe: storedFringe,
          valance: itemDetails.canopy.valance ?? option.Valance.Canopy
        }
      );

      const layout = itemDetails.layout ? itemDetails.layout : startingLayout;
      const newObj = Object.assign(
        {},
        { ...itemDetails },
        { canopy },
        { layout }
      ) as CustomUmbrellaOrder;
      // Raised before the write that triggers the watchers, and lowered in the
      // finally only after their flush has run (see `hydrating`).
      this.hydrating = true;
      this.item_details = Object.assign({}, this.item_details, newObj);
      if (this.item_details.notes && this.item_details.notes.length > 0) {
        this.setNotes();
      } else {
        this.item_details.notes = [];
      }
    } catch (error) {
      console.error("error occurred when editing a cart item:", error);
    } finally {
      // Lowered in an inner finally so it drops on every exit. Left up, it
      // would silently stop the rep's own Single -> Double and valance-style
      // changes from seeding their fabrics for the rest of the page's life.
      try {
        this.clearRestrictedBullionFringe();
        this.lastMainFabricCodes = (this.item_details.canopy
          .mainFabric as FabricSwatch[]).map(f => f.mfr_code);
        this.checkMainCanopy();
        this.setLayoutName();
        this.checkVentMiddle();
        // Must run after setLayoutName(): isUndersideDisabled reads
        // isDoubleVent off layoutName, which is only set there. Runs before
        // updateSKU() so the SKU reflects the cleared fabric.
        this.clearRestrictedUndersideFabric();
        // Let the watchers the load triggered — layoutName's Double branch,
        // the valance style — run while `hydrating` is still up, so they keep
        // the loaded fabrics instead of copying main over them. What this
        // relies on, for anyone changing it:
        //   - every write that triggers one of those watchers happens before
        //     this line, not after it;
        //   - each watcher reads `hydrating` before its own first await;
        //   - nothing between the item_details write and this line yields to
        //     the user (a network call, say). A plain await is harmless — the
        //     flush just runs during it — but a rep action taken while the
        //     flag is up would be mistaken for the load and not seed.
        await this.$nextTick();
      } finally {
        this.hydrating = false;
      }
      // The loaded fabrics are now final. Where one differs from main, keep a
      // later main-fabric change from overwriting it — on the cart path too.
      this.markLoadedVentFabricsAsManual();
      await this.updateSKU();
    }
  }

  /**
   * FUPOF-193 — preload this page from a Shade Designer configuration code.
   *
   * The API has already done the SD -> SQ transform (finial finish
   * normalization, spigot sentinel, top cover promoted off the base), so the
   * umbrella line's `config` is the same `{ layout, frame, canopy }` record an
   * edited line carries, with fabric slots still as code references —
   * applyStoredItem resolves those exactly as it does for a SKU-parsed line.
   *
   * The base and top-cover lines are stashed on the instance and added to the
   * quote alongside the umbrella in addToQuote(); only the umbrella is
   * reviewed here.
   */
  protected async prepDataFromSharedConfig(shareId: string): Promise<void> {
    let resolved: ResolvedSharedConfig;
    try {
      resolved = await this.configFileService.resolveShareCode(shareId);
    } catch (err) {
      GenericError.popup((err as Error).message);
      this.$router.replace("/collections/umbrella");
      return;
    }
    const umbrellaLine = resolved.lines.find(
      line => line.productType === ProductType.Umbrella
    );
    if (!umbrellaLine) {
      GenericError.popup("This configuration code has no umbrella on it.");
      this.$router.replace("/collections/umbrella");
      return;
    }

    this.sharedDesignId = resolved.share_id;
    // The design's base and top cover seed the base card rather than being
    // built behind the rep's back. Resolving the codes to documents is what
    // lets the card show the design's base already selected, with its cover and
    // finish, so "verify your selections" is something the rep can actually do.
    const { selection, warning } = await resolveSharedBaseSelection(
      resolved.lines.find(l => l.productType === ProductType.Base) ?? null,
      resolved.lines.find(l => l.productType === ProductType.Accessory) ?? null,
      { getItem: (model: string) => this.getItem(model) }
    );
    this.basePreselect = selection;
    this.designBasePending = !!selection;
    // The design named a base this catalog can't offer, so it is being added
    // without it: not as designed, even if the rep touches nothing. The
    // umbrella key is filled in once loading settles (captureSharedBaseline).
    this.sharedOrigin = {
      config: "",
      ...this.designedMemberKeys(selection),
      ...(warning && !selection ? { base: UNRESOLVED_DESIGN_KEY } : {})
    };
    if (warning) NotificationService.show(warning, "warning", 12000);

    // applyStoredItem reads only `model` and `item_details` off the line, so a
    // synthetic one is enough and avoids inventing price/qty values that the
    // footer is about to compute anyway.
    await this.applyStoredItem(({
      model: umbrellaLine.model,
      item_details: umbrellaLine.config
    } as unknown) as LineItem);

    this.reconcileTrimPreset();

    // applyStoredItem's finally block calls updateSKU() only — correct for an
    // edit, where the price came off the stored line, but this is a fresh add
    // and the footer would otherwise sit at $0.00.
    await this.updatePriceAndSKU();

    resolved.warnings.forEach(warning =>
      NotificationService.show(warning, "warning", 12000)
    );
    await this.captureSharedBaseline();
  }

  /**
   * FUPOF-193: snapshot the configuration once loading has fully settled.
   *
   * Taken here rather than off the stored line because hydration is not a pure
   * read — applyStoredItem's finally block re-derives the layout name, the vent
   * middle and the restricted underside fabric, so a line can differ from its
   * stored form before the rep has touched anything. Snapshotting after that
   * settles — and after one tick, so the trim/fabric watchers have run — means
   * any later difference is genuinely the rep's doing.
   *
   * @param storeItem the stored line, on the edit path; omitted on the share
   *   path where sharedDesignId is already set.
   */
  protected async captureSharedBaseline(storeItem?: LineItem): Promise<void> {
    if (storeItem) {
      this.sharedDesignId = sharedDesignCode(storeItem);
    }
    if (!this.sharedDesignId) {
      this.sharedConfigFingerprint = null;
      this.sharedOrigin = null;
      return;
    }
    // Let queued watchers drain first. Loading assigns selectedTrimOption and
    // the fabric arrays, and those watchers seed/clear trim fabrics on the next
    // tick — snapshotting before they run would fingerprint a config that is
    // about to change on its own, and an untouched design would then look
    // edited and silently lose its pill.
    await this.$nextTick();
    this.sharedConfigFingerprint = this.umbrellaDesignKey();
    if (this.sharedOrigin) {
      this.sharedOrigin.config = this.sharedConfigFingerprint;
    }
  }

  /**
   * The umbrella on this page as a design key — its model included, which
   * lives outside `item_details` (see shared_design.designKey).
   */
  private umbrellaDesignKey(): string {
    return designKey({
      product_type: ProductType.Umbrella,
      model: this.model,
      item_details: this.item_details
    });
  }

  /** A design's base and top cover lines, as design keys. */
  private designedMemberKeys(
    selection: BaseSelection | null
  ): Pick<SharedDesignOrigin, "base" | "cover"> {
    return {
      base: selection ? baseLineDesignKey(selection) : null,
      cover: selection ? topCoverLineModel(selection) : null
    };
  }

  /**
   * FUPOF-193: open the umbrella's setup in the Base card.
   *
   * The members are found by the shared render rule (utility/line_setup), so
   * the card shows exactly the base the cart groups under this umbrella. The
   * stored base is turned back into a selection by the same resolver a Shade
   * Designer code goes through: it re-fetches the base document, matches the
   * finish, and splits the cover's finish off its model. Only the line shapes
   * differ, so they are adapted to its input here.
   *
   * Nothing recorded here is used to *write*. The save resolves every member
   * again by setup id against the store at that moment.
   */
  protected async prepSetupForEdit(index: number): Promise<void> {
    const group = setupGroupAt(this.storeItems, index);
    if (!group || group.anchor !== index || group.base === null) return;
    // Raised before anything else, and before the first await: from the moment
    // this setup is known to have a base, a save must not read the card's
    // still-empty selection as "No Base" (see awaitingBaseSettle).
    this.awaitingBaseSettle = true;
    const baseLine = this.storeItems[group.base];
    const coverLine =
      group.cover !== null ? this.storeItems[group.cover] : null;
    this.loadedBaseMember = baseLine;
    this.loadedHasCover = !!coverLine;

    // buildBaseLine stores the hydrated shape — `baseFinish` a Finish object —
    // but the resolver takes the flat, code-and-handle shape a shared design
    // arrives in.
    const stored = ((baseLine.item_details as any)?.base ?? {}) as any;
    const baseFinish =
      stored.baseFinish && typeof stored.baseFinish === "object"
        ? stored.baseFinish.handle
        : stored.baseFinish;
    let resolved: ResolvedBaseSelection;
    try {
      resolved = await resolveSharedBaseSelection(
        ({
          config: {
            base: baseLine.model,
            baseFinish,
            baseStem: stored.baseStem ?? null,
            baseOptions: stored.baseOptions ?? {}
          }
        } as unknown) as SharedConfigLine,
        coverLine
          ? (({ model: coverLine.model } as unknown) as SharedConfigLine)
          : null,
        { getItem: (model: string) => this.getItem(model) }
      );
    } catch (err) {
      // Items.getItem has already toasted the failed request, and then throws
      // reading a product off an undefined response. Either way the card
      // cannot show this base, which is the unresolved case below.
      resolved = { selection: null };
    }

    const selection = resolved.selection;
    if (!selection) {
      // The card starts at No Base, but the line stays until the rep picks No
      // Base on purpose — the card's note says so. There is no seed for the
      // card to settle, so the guard hands over to baseMemberUnresolved.
      this.awaitingBaseSettle = false;
      this.baseMemberUnresolved = true;
      if (resolved.warning) {
        NotificationService.show(resolved.warning, "warning", 12000);
      }
      return;
    }
    this.loadedBaseKey = this.baseLineKey(selection);
    this.loadedCoverKey = this.coverLineKey(selection);
    this.basePreselect = selection;
  }

  /**
   * FUPOF-193: the jump-link rail's targets.
   *
   * Optional Features is deliberately one entry covering the whole group
   * rather than one per card — Valance, Fringe, Finial, Bottom Pole, Spigot and
   * Rib would make the rail longer than the content it navigates, and several
   * of them are conditional on the product line anyway. Its target is the
   * group heading, not a card.
   */
  protected get jumpSections(): JumpLinkSection[] {
    return [
      { id: "section-model", label: "Model" },
      { id: "section-canopy", label: "Canopy" },
      { id: "section-frame", label: "Frame Finish" },
      { id: "section-base", label: "Base" },
      { id: "section-optional", label: "Optional Features" }
    ];
  }

  /**
   * Open the section being jumped to before the scroll lands on it.
   *
   * All four cards start open, but the rep can have collapsed one — and a link
   * that scrolls to a collapsed card has only done half the job, leaving them
   * looking at a title bar they still have to click. AccordionSection.expand()
   * only ever opens, so this cannot slam one shut under them.
   */
  protected onJump(id: string): void {
    const refName = {
      "section-model": "sectionModel",
      "section-canopy": "sectionCanopy",
      "section-frame": "sectionFrame",
      "section-base": "sectionBase"
    }[id];
    if (!refName) return;
    const section = this.$refs[refName] as { expand?: () => void } | undefined;
    if (section && typeof section.expand === "function") section.expand();
  }

  /**
   * FUPOF-193: the rep changed something in the base card.
   *
   * The selection and its prices are held here, not merged into
   * `item_details` — see the `baseSelection` field for why. The umbrella's own
   * price and SKU are deliberately NOT refreshed from here: only the SKU call
   * consumes the base block, and routing this through updatePriceAndSKU would
   * re-price the umbrella on every wheels toggle across its ~25 call sites.
   */
  protected onBaseChange(change: BaseSelectionChange): void {
    const hadBase = !!this.baseSelection || !!this.baseSku;
    // FUPOF-193: the card tags the emit that settles the preselect it was
    // given (`fromPreselect`) — the reply to that preselect's own pricing. If
    // the rep changes anything first, that reply is dropped and the first emit
    // is theirs, untagged. So:
    //  - a settled preselect becomes the baseline. The card can land a stored
    //    base slightly differently from how it was stored (a stem or finish
    //    fallback, catalog drift); comparing a save against the *settled* form
    //    means opening a design and saving it untouched rewrites nothing and
    //    marks nothing adjusted — which, the flag being sticky, would be
    //    permanent. A rep's change is never taken as the baseline.
    //  - a null that settles the preselect means the card couldn't offer the
    //    base (discontinued, or not for this umbrella) — not that the rep chose
    //    No Base. Any untagged emit is the rep's own doing, including picking
    //    No Base on purpose, which is what releases the line for removal.
    if (change.fromPreselect && change.selection) {
      this.loadedBaseKey = this.baseLineKey(change.selection);
      this.loadedCoverKey = this.coverLineKey(change.selection);
      if (this.sharedOrigin) {
        // Share-code add: the design's base as this catalog shows it.
        Object.assign(
          this.sharedOrigin,
          this.designedMemberKeys(change.selection)
        );
      }
    }
    this.awaitingBaseSettle = false;
    this.baseMemberUnresolved = !!change.fromPreselect && !change.selection;
    this.baseSelection = change.selection;
    this.baseUnitPrice = change.basePrice;
    this.coverUnitPrice = change.coverPrice;
    if (!change.selection) this.baseSku = "";
    this.designBasePending = false;
    // A preselect settling is the page's doing, never the rep's: take where
    // it landed as read rather than asking about it.
    if (change.fromPreselect) this.settleDeviationGuard();
    // The base block feeds /products/sku, so a base SKU has to be fetched —
    // but not for the card's opening "no base" emit on a page that never had
    // one, which would duplicate the SKU call created() already makes.
    if (change.selection || hadBase) this.updateSKU();
  }

  /**
   * The base as the ConfigFile carries it: codes and handles, not documents.
   *
   * `"Spigot"` is nulled out. It is an attachment style rather than a stem, and
   * the SKU pipeline expects no stem segment for one — the same twist the
   * pricing payload applies.
   */
  protected get baseConfigFileBlock(): ConfigFile["base"] {
    const selection = this.baseSelection;
    if (!selection) {
      return { base: null, baseFinish: null, baseStem: null };
    }
    const stem = selection.baseStem;
    return {
      base: selection.base.model,
      baseFinish: selection.baseFinish?.handle ?? null,
      baseStem: stem === SPIGOT_STEM ? null : (stem as option.Stem | null),
      // Wheels only — see baseOptionsForLine. A topCover here makes
      // /products/sku answer with a combined "<base> & <cover>" SKU, which the
      // base line would then wear while the cover line carries it too.
      baseOptions: baseOptionsForLine(selection)
    };
  }

  /**
   * Per-unit price of the lines this page will add besides the umbrella, for
   * the footer's totals only. It must never reach the umbrella's `unit_price`
   * or the cart counts the base twice.
   */
  protected get companionUnitPrice(): number {
    return this.baseUnitPrice + this.coverUnitPrice;
  }

  /**
   * This page was opened from the cart to edit a line, so it is the setup
   * editor: the Base card edits the setup's base and cover lines (FUPOF-193).
   * Gated on `query.cart` rather than `editMode`, which addToQuote also raises
   * after a successful add.
   */
  protected get isEditingFromCart(): boolean {
    return !!this.$route.query.cart;
  }

  /**
   * FUPOF-193: something the footer is about to save is still being fetched —
   * the umbrella's price or SKU, the base SKU that comes back with it, or the
   * Base card's own price. A submit now would write whatever the previous
   * request left behind: the old base's SKU beside the new model, or the old
   * price. The footer holds its button until this clears.
   */
  protected get pricingBusy(): boolean {
    return this.pendingRequests > 0 || this.baseCardBusy || this.skuFailed;
  }

  protected onBaseBusy(busy: boolean): void {
    this.baseCardBusy = busy;
  }

  /**
   * "Update Design" whenever the umbrella is reopened from the cart — with a
   * base or without. The cart labels every umbrella's pencil "Edit {line}
   * Design" (Trey's own example, 3EH32, has no base), and this page can add a
   * base to one that has none, so the footer names the same thing the pencil
   * opened. It read "Update Item" for a base-less umbrella until 2026-09-21.
   *
   * Also "Update Design" straight after Add to Quote when that add saved more
   * than the umbrella — its base, and the base's top cover (Trey, 2026-09-30).
   * The confirmation just listed several items; "Update Item" undersold them.
   * A lone umbrella still reads "Update Item".
   */
  protected get footerEditLabel(): string {
    return this.isEditingFromCart || this.savedWithCompanions
      ? "Update Design"
      : "Update Item";
  }

  /**
   * FUPOF-193: the Base card's lead-in in the setup editor — spec §4.4, copy
   * verbatim. Its main job is the safety net: an update that will remove a
   * base says so before the rep clicks.
   *
   * The "no longer offered" case is checked before the removal cases on
   * purpose. The card also shows No Base then, but the rep did not choose it,
   * and the line is kept (see baseMemberUnresolved).
   */
  protected get setupBaseNote(): string {
    if (!this.isEditingFromCart) return "";
    const member = this.loadedBaseMember;
    if (member) {
      if (this.baseMemberUnresolved) {
        return `${member.model} is no longer offered, so it isn't shown here. It stays on the quote unless you choose No Base and update.`;
      }
      if (!this.baseSelection && !this.awaitingBaseSettle) {
        return this.loadedHasCover
          ? `Updating will remove ${member.display_name} and its top cover from the quote.`
          : `Updating will remove ${member.display_name} from the quote.`;
      }
      return "Changes to this base update its line on the quote.";
    }
    // No base in this setup, so choosing one adds a line. Warn when the quote
    // already holds a base that isn't part of any setup — it may well be this
    // umbrella's, and nothing links the two (that's a later stage).
    const memberBases = findSetupGroups(this.storeItems).map(g => g.base);
    const standalone = this.storeItems.filter(
      (line, i) =>
        line.product_type === ProductType.Base && memberBases.indexOf(i) === -1
    ).length;
    if (standalone === 1) {
      return "This quote already has a base that isn't linked to an umbrella. Choosing a base here adds another base line.";
    }
    if (standalone > 1) {
      return `This quote already has ${standalone} bases that aren't linked to an umbrella. Choosing a base here adds another base line.`;
    }
    return "";
  }

  /**
   * True while this line is still exactly the design the code produced. Any
   * configuration change marks the line adjusted; the code itself stays.
   */
  protected get isUnchangedSharedDesign(): boolean {
    return (
      !!this.sharedDesignId &&
      !!this.sharedConfigFingerprint &&
      this.umbrellaDesignKey() === this.sharedConfigFingerprint
    );
  }

  /**
   * FUPOF-193: the design this page is judged against — the one a code just
   * resolved to, or the one the cart's umbrella line carries. Null for a line
   * from before origins existed: there is nothing to say "as designed" by.
   */
  private get designOrigin(): SharedDesignOrigin | null {
    if (!this.sharedDesignId) return null;
    if (this.sharedOrigin) return this.sharedOrigin;
    const index = parseInt(this.$route.query.cart as string, 10);
    const line = isNaN(index) ? null : this.storeItems[index];
    return line ? sharedDesignOrigin(line) : null;
  }

  /**
   * Whether the page, saved now, would no longer be exactly its design — the
   * same comparison the save makes (judgeSharedDesign, and judgeSetupAnchor
   * for the base and cover). Null when there is no design to compare with.
   *
   * A base the card has not shown yet, or cannot show, is not compared: the
   * rep has decided nothing about it, and the save leaves it alone too.
   */
  private get designDeviates(): boolean | null {
    const origin = this.designOrigin;
    if (!origin || !origin.config) return null;
    if (this.umbrellaDesignKey() !== origin.config) return true;
    if (
      this.designBasePending ||
      this.awaitingBaseSettle ||
      this.baseMemberUnresolved ||
      origin.base === undefined
    ) {
      return false;
    }
    const selection = this.baseSelection;
    const base = selection ? baseLineDesignKey(selection) : null;
    const cover = selection ? topCoverLineModel(selection) : null;
    return base !== origin.base || cover !== (origin.cover ?? null);
  }

  /**
   * Take the page as it stands without asking: on the design, remember it for
   * Cancel and ask about the next change away; off it, there is nothing left
   * to warn about.
   */
  private settleDeviationGuard(): void {
    const deviates = this.designDeviates;
    if (deviates === null) return;
    this.deviationAcknowledged = deviates;
    if (deviates) return;
    this.designSnapshot = {
      model: this.model,
      // Notes are not configuration, and the note boxes are the live copy:
      // an empty list makes applyStoredItem leave them as the rep has them.
      details: JSON.stringify({ ...this.item_details, notes: [] }),
      isStockOnly: this.isStockOnly,
      base: this.designBasePending ? this.basePreselect : this.baseSelection,
      baseUnresolved: this.baseMemberUnresolved
    };
  }

  protected acknowledgeDeviation(): void {
    this.deviationAcknowledged = true;
    this.showDeviationModal = false;
  }

  /**
   * Cancel: put the page back on the design. The change is already on screen
   * behind the modal — this page's fields are bound straight to its state, so
   * there is no one place to hold a change before it lands — and reloading the
   * snapshot through applyStoredItem undoes it along with everything the
   * watchers derived from it.
   */
  protected async revertToDesign(): Promise<void> {
    this.showDeviationModal = false;
    const snapshot = this.designSnapshot;
    if (!snapshot) return;
    this.revertingDeviation = true;
    try {
      this.isStockOnly = snapshot.isStockOnly;
      this.ribAutoSwitchedToGrommets = false;
      this.ribBeforeAutoSwitch = null;
      // applyStoredItem raises these again where the design's own fabrics
      // differ from main; it never lowers one.
      this.ventTopFabricManuallySet = false;
      this.ventMiddleFabricManuallySet = false;
      this.valanceFabricManuallySet = false;
      await this.applyStoredItem(({
        model: snapshot.model,
        item_details: JSON.parse(snapshot.details)
      } as unknown) as LineItem);
      this.reconcileTrimPreset();
      await this.updatePriceAndSKU();

      const card = this.$refs.baseSelector as
        | { clearBase(): void }
        | undefined;
      const baseChanged =
        this.baseLineKey(snapshot.base) !==
          this.baseLineKey(this.baseSelection) ||
        this.coverLineKey(snapshot.base) !==
          this.coverLineKey(this.baseSelection);
      if (snapshot.base && baseChanged) {
        // A fresh object, so the card's preselect watcher sees a change. It
        // re-prices the base and reports back tagged, which settles the guard.
        this.designBasePending = true;
        this.basePreselect = { ...snapshot.base };
      } else if (baseChanged && card) {
        card.clearBase();
        // The card reports a cleared base as the rep choosing No Base, which
        // would release a base it could never show for removal on save.
        this.baseMemberUnresolved = snapshot.baseUnresolved;
      }
      await this.$nextTick();
    } finally {
      this.revertingDeviation = false;
    }
    this.settleDeviationGuard();
  }

  /**
   * FUPOF-193 — keep the trim pickers and the trim fabrics in agreement.
   *
   * setLayoutName() derives selectedTrimOption from layout.preset alone. A
   * shared design that carries trim fabrics under a non-D preset would render
   * with the trim pickers hidden while the fabrics sit in item_details, and the
   * next computePreset() would silently drop them. Trust a stored D1/D2/D3;
   * otherwise synthesise the option from which trim fabrics actually arrived.
   */
  protected reconcileTrimPreset(): void {
    const preset = this.item_details.layout?.preset;
    if (
      preset === option.Preset.D1 ||
      preset === option.Preset.D2 ||
      preset === option.Preset.D3
    ) {
      return;
    }
    const canopy = this.item_details.canopy;
    if (canopy.mainTrimFabricInner) {
      this.selectedTrimOption = "double";
    } else if (canopy.mainTrimFabric) {
      this.selectedTrimOption = "single";
    } else {
      return;
    }
    this.item_details.layout.preset = this.computePreset();
    this.setLayoutName();
  }

  /**
   * FUPOF-193 — protect a deliberately-different vent or valance fabric on a
   * loaded line, whether it came from a Shade Designer code or from the cart.
   *
   * mainFabricChange() mirrors the main fabric into the vent and valance slots
   * unless they are marked as manually set, and a loaded line arrives with
   * those flags false. Without this, the rep's first main-fabric change after
   * reopening a line would silently overwrite a vent or valance fabric chosen
   * on purpose. Called from applyStoredItem once its watcher flush has run, so
   * it reads the fabrics as loaded. Sets the flags only where the loaded value
   * genuinely differs from main; never clears one.
   */
  protected markLoadedVentFabricsAsManual(): void {
    const canopy = this.item_details.canopy;
    const mainCodes = (canopy.mainFabric as FabricSwatch[]).map(
      f => f?.mfr_code
    );
    const differs = (slot: FabricSwatch[]): boolean =>
      slot.length > 0 &&
      slot.some((f, i) => f?.mfr_code !== mainCodes[i % mainCodes.length]);

    if (differs(canopy.ventTopFabric as FabricSwatch[])) {
      this.ventTopFabricManuallySet = true;
    }
    if (differs(canopy.ventMiddleFabric as FabricSwatch[])) {
      this.ventMiddleFabricManuallySet = true;
    }
    if (differs(canopy.valanceFabric as FabricSwatch[])) {
      this.valanceFabricManuallySet = true;
    }
  }

  protected setNotes(): void {
    const uf = [
      "model",
      "canopy",
      "frame",
      "valance",
      "fringe",
      "finial",
      "bottomPole",
      "rib",
      "spigot"
    ];
    uf.forEach(field => {
      const obj = this.item_details.notes!.find(e => e.field === field);
      if (obj) {
        let content = obj.content;
        if (field === "spigot") {
          content = content.replace(/^Stainless Steel\.?\s*/i, "").trim();
        }
        if (field === "rib") {
          content = content.replace(/^Grommets\.?\s*/i, "").trim();
          content = content.replace(/^Pockets\.?\s*/i, "").trim();
        }
        if (field === "bottomPole") {
          content = content
            .replace(/^Bar Height Bottom Pole upgrade\.?\s*/i, "")
            .trim();
        }
        if (field === "finial") {
          content = content.replace(/^Stainless Steel Upgrade\.?\s*/i, "").trim();
          content = content.replace(/^Chrome\.?\s*/i, "").trim();
          content = content.replace(/^Vertex\.?\s*/i, "").trim();
          content = content.replace(/^Classic Ball\.?\s*/i, "").trim();
        }
        this.noteObj[field] = content;
      }
    });
  }

  protected addNotesToQuote(): void {
    this.item_details.notes = [];
    for (const [key, value] of Object.entries(this.noteObj)) {
      let content = value;
      if (
        key === "spigot" &&
        this.handle === ProductLineName.Aurora &&
        this.item_details.frame.spigot === option.Spigot.StainlessSteel
      ) {
        const spigotLabel = "Stainless Steel";
        content = content ? `${spigotLabel}. ${content}` : spigotLabel;
      }
      if (key === "rib" && this.isNonStandardRib) {
        const ribLabel = this.nonStandardRibNote;
        content = content ? `${ribLabel}. ${content}` : ribLabel;
      }
      if (key === "bottomPole" && this.isNonStandardBottomPole) {
        const bpLabel = this.nonStandardBottomPoleNote;
        content = content ? `${bpLabel} ${content}` : bpLabel;
      }
      if (key === "finial" && this.isNonStandardFinial) {
        const finialLabel = this.nonStandardFinialNote;
        content = content ? `${finialLabel}. ${content}` : finialLabel;
      }
      if (key === "finial" && this.hasFinialFinishNote) {
        const finishLabel = this.finialFinishNote;
        content = content ? `${finishLabel}. ${content}` : finishLabel;
      }
      this.item_details.notes.push({
        field: key as NoteFields,
        content
      });
    }
  }

  /**
   * @param message optional caption rendered under the spinner. Used on the
   *   shared-design path, where the wait is longer than a normal page load —
   *   the code is resolved and its base fetched before anything renders — and
   *   an unlabelled spinner gives the rep no confirmation that the code they
   *   just entered is the one being loaded.
   */
  protected showLoader(message?: string): void {
    this.loader = this.$loading.show(
      { opacity: 1 },
      message
        ? {
            // vue-loading-overlay takes VNodes for its before/default/after
            // slots; `after` puts the caption below the spinner.
            after: this.$createElement(
              "p",
              {
                class: "mt-4 mb-0 text-sm font-medium text-brand-700"
              },
              message
            )
          }
        : undefined
    );
  }

  protected closeLoader(): void {
    setTimeout(() => {
      this.loader.hide();
    }, 300);
    this.$emit("ready");
  }

  get showBottomPole(): boolean {
    let show = false;
    if (this.hasBottomPole.includes(this.handle)) {
      show = true;
    }
    return show;
  }

  get vCanopyObj() {
    return this.$v.item_details.canopy;
  }

  get canopyEvenErrors(): string[] {
    const errors: string[] = [];
    const fields = [
      { label: "Main fabric", arr: this.item_details.canopy.mainFabric },
      { label: "Top vent fabric", arr: this.item_details.canopy.ventTopFabric },
      ...(this.layoutName === option.StandardLayoutNames.Double
        ? [{ label: "Double vent fabric", arr: this.item_details.canopy.ventMiddleFabric }]
        : [])
    ];
    for (const f of fields) {
      if (f.arr && f.arr.length > 1 && f.arr.length % 2 !== 0) {
        errors.push(
          `${f.label}: more than one fabric must be selected in groups of two; canopies have an even number of segments. Please add or remove a fabric.`
        );
      }
    }
    return errors;
  }

  get fringeFabricsReady(): boolean {
    return process.env.VUE_APP_FRINGE_FABRICS_READY === "true";
  }

  private hasEvenError(arr: { length: number }): boolean {
    return arr && arr.length > 1 && arr.length % 2 !== 0;
  }

  get hasMainFabricEvenError(): boolean {
    return this.hasEvenError(this.item_details.canopy.mainFabric);
  }

  get hasDoubleVentEvenError(): boolean {
    return this.layoutName === option.StandardLayoutNames.Double &&
      this.hasEvenError(this.item_details.canopy.ventMiddleFabric);
  }

  get hasValanceEvenError(): boolean {
    return this.hasEvenError(this.item_details.canopy.valanceFabric);
  }

  get canopyAlerts(): string[] {
    return this.canopyEvenErrors;
  }

  get vFrameObj() {
    return this.$v.item_details.frame;
  }

  protected async setDefaults(): Promise<void> {
    const defaultConfig = this.defaultConfigFile!;
    const mainFabric = await this.getFabricObject(
      defaultConfig.canopy!.mainFabric[0]
    );
    this.selected = this.items[0];
    this.model = this.selected!.model;
    this.item_details.frame.finish = defaultConfig.frame!.finish;
    this.item_details.canopy.mainFabric = [mainFabric];
    this.lastMainFabricCodes = [mainFabric.mfr_code];
    this.item_details.canopy.ventTopFabric = [mainFabric];
    this.ventTopFabricManuallySet = false;
    this.ribAutoSwitchedToGrommets = false;
    this.ribBeforeAutoSwitch = null;
    if (grommetOnlyModels.includes(this.selected!.model)) {
      this.item_details.canopy.rib = option.Rib.Grommets;
      this.item_details.canopy.ribFabric = null;
    } else {
      this.item_details.canopy.rib = defaultConfig.canopy!.rib;
      if (defaultConfig.canopy!.rib === option.Rib.Pockets) {
        this.item_details.canopy.ribFabric = mainFabric;
      }
    }
    // Set default finial type based on collection
    if (
      this.handle === ProductLineName.Eclipse ||
      this.handle === ProductLineName.Greenwich ||
      this.handle === ProductLineName.GreenwichGSeries
    ) {
      this.item_details.frame.finial = option.Finial.Vertex;
    } else if (this.hasFinial.includes(this.handle)) {
      this.item_details.frame.finial = option.Finial.Ball;
    }
    // Set default spigot based on collection
    if (this.handle === ProductLineName.Aurora) {
      this.item_details.frame.spigot = option.Spigot.Standard;
    } else if (this.handle === ProductLineName.Eclipse) {
      this.item_details.frame.spigot = option.Spigot.StainlessSteel;
    } else {
      this.item_details.frame.spigot = null;
    }
    // Set default finial finish based on collection
    if (this.handle === ProductLineName.Eclipse) {
      this.item_details.frame.finialFinish = option.FinialFinishType.SS;
    } else if (this.hasTPUMatchFinish) {
      // Monterey Pulley Lift, Crank, Auto Tilt default to TPU Match
      this.item_details.frame.finialFinish = option.FinialFinishType.TPU;
    } else {
      // Greenwich and Monterey G-Series default to Chrome
      this.item_details.frame.finialFinish = option.FinialFinishType.CH;
    }
  }

  protected async updatePriceAndSKU(): Promise<void> {
    await this.updatePrice();
    await this.updateSKU();
  }

  /**
   * Both price paths write `itemPrice`, so they share one sequence: only the
   * latest request's reply is kept (see pricingBusy for why that matters).
   */
  protected async updatePrice(): Promise<void> {
    if (
      this.item_details.frame.finish &&
      this.item_details.canopy.mainFabric.length > 0
    ) {
      this.checkVentMiddle();
      this.checkMainCanopy();
      this.checkCanopyLayout();
      const seq = ++this.priceRequestSeq;
      this.pendingRequests++;
      try {
        const price = await this.productService.getUmbrellaPrice({
          model: this.model,
          item_details: this.item_details
        });
        if (seq !== this.priceRequestSeq) return;
        console.log(
          "Fringe:",
          this.item_details.canopy.fringe,
          "| Total Price:",
          price.umbrella
        );
        this.itemPrice = price.umbrella!;
      } catch (err) {
        if (err instanceof AuthError) {
          AuthError.logout();
        }
        GenericError.popup((err as any).message);
      } finally {
        this.pendingRequests--;
      }
    } else {
      this.getMSRP();
    }
  }

  protected async updateSKU(): Promise<void> {
    const data = this.transformDataToConfigFile();
    // Last request wins. The rep can change the base (or anything else) again
    // before this answers, and replies can arrive out of order; a stale one
    // must not land the previous base's SKU next to the new model — for
    // NetSuite that is a different item.
    const seq = ++this.skuRequestSeq;
    // Captured now, not read at reply time: whether this request asked for a
    // base SKU is what decides whether an empty one means failure.
    const hadBase = !!data.base && !!(data.base as any).base;
    this.pendingRequests++;
    try {
      // One request for both. /products/sku has always returned the base SKU
      // alongside the umbrella's, and now that transformDataToConfigFile emits
      // a real base block there is one to collect — so the base line's SKU
      // costs no extra round-trip. Verified that populating the base block
      // leaves the umbrella SKU byte-identical.
      const {
        umbrella,
        base
      } = await this.productService.createUmbrellaAndBaseSKU(data);
      if (seq !== this.skuRequestSeq) return;
      // The service does not throw on failure — it returns SKU_UNAVAILABLE in
      // place of each SKU, so the catch below never sees a failed request.
      // Browser-verified: a 500 here re-enabled the button and saved
      // "Not Available..." as the SKU of both lines. An empty SKU is just as
      // unusable, except a base SKU with no base, which is correct.
      if (
        umbrella === SKU_UNAVAILABLE ||
        !umbrella ||
        (hadBase && (base === SKU_UNAVAILABLE || !base))
      ) {
        this.skuFailed = true;
        GenericError.popup("Unable to get SKU data. Please try again.");
        return;
      }
      this.sku = umbrella;
      this.baseSku = base;
      this.skuFailed = false;
    } catch (err) {
      // Only the newest request's failure means anything: an older one has
      // already been superseded by the request that is still running.
      if (seq !== this.skuRequestSeq) return;
      this.skuFailed = true;
      if (err instanceof AuthError) {
        AuthError.logout();
      }
      GenericError.popup((err as any).message);
    } finally {
      this.pendingRequests--;
    }
  }

  protected transformDataToConfigFile(): ConfigFile {
    /**
     * Encode a fabric reference for the SKU pipeline / saved configs.
     * Returns "<mfr_code>::<group>" when the fabric carries a name.group
     * (used by the API to disambiguate duplicate mfr_codes — e.g. SENS D-020
     * across Coquette / Finesse / Enea — and harmless when emitted on a
     * non-duplicate fabric since the API only consults the suffix when the
     * bare lookup is ambiguous). Falls back to bare "<mfr_code>" otherwise.
     */
    const encodeFabric = (f: FabricSwatch): string => {
      const group = f.name && f.name.group;
      return group ? `${f.mfr_code}::${group}` : f.mfr_code;
    };

    const fabricArray = (this.item_details.canopy.mainFabric as Array<
      FabricSwatch
    >).map(encodeFabric);
    const fabricArrayVentTop = this.selected!.attributes.vent
      ? (this.item_details.canopy.ventTopFabric as Array<FabricSwatch>).map(
          encodeFabric
        )
      : [];
    const fabricArrayVentMid = (this.item_details.canopy
      .ventMiddleFabric as Array<FabricSwatch>).map(encodeFabric);
    const fabricArrayValance = (this.item_details.canopy.valanceFabric as Array<
      FabricSwatch
    >).map(encodeFabric);
    const fabricArrayFringe = (this.item_details.canopy.fringeFabric as Array<
      FabricSwatch
    >).map(encodeFabric);
    const data: ConfigFile = {
      layout: this.item_details.layout,
      shape: { model: this.selected?.model || "" },
      base: this.baseConfigFileBlock,
      frame: {
        finish: this.item_details.frame.finish,
        finial: this.item_details.frame.finial,
        finialFinish: this.item_details.frame.finialFinish,
        bottomPole: this.item_details.frame.bottomPole,
        ...(this.handle === ProductLineName.Aurora
          ? { spigot: this.item_details.frame.spigot }
          : {})
      },
      canopy: {
        mainCanopy: this.item_details.canopy.mainCanopy,
        mainTrimFabric: this.item_details.canopy.mainTrimFabric
          ? encodeFabric(this.item_details.canopy.mainTrimFabric)
          : null,
        mainTrimFabricInner: this.item_details.canopy.mainTrimFabricInner
          ? encodeFabric(this.item_details.canopy.mainTrimFabricInner)
          : null,
        mainFabric: fabricArray,
        ventTopFabric: fabricArrayVentTop,
        ventMiddle: this.item_details.canopy.ventMiddle,
        ventMiddleFabric: fabricArrayVentMid,
        valanceFabric: fabricArrayValance,
        fringe: this.item_details.canopy.fringe,
        fringeFabric: fabricArrayFringe,
        ventTrimFabric: this.item_details.canopy.ventTrimFabric
          ? encodeFabric(this.item_details.canopy.ventTrimFabric)
          : null,
        valance: this.item_details.canopy.valance,
        bindingFabric: this.item_details.canopy.bindingFabric
          ? encodeFabric(this.item_details.canopy.bindingFabric)
          : null,
        rib: this.item_details.canopy.rib,
        ribFabric:
          !this.item_details.canopy.rib ||
          this.item_details.canopy.rib === option.Rib.Grommets
            ? null
            : fabricArray[0],
        undersideFabric: this.item_details.canopy.undersideFabric
          ? encodeFabric(this.item_details.canopy.undersideFabric)
          : null
      }
    };
    return data;
  }

  protected async getMSRP(): Promise<void> {
    const seq = ++this.priceRequestSeq;
    this.pendingRequests++;
    try {
      const price = await this.productService.getPriceDoc(this.model);
      if (seq !== this.priceRequestSeq) return;
      this.itemPrice = price.a!;
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      }
      GenericError.popup((err as any).message);
    } finally {
      this.pendingRequests--;
    }
  }

  protected checkVentMiddle(): void {
    if (this.layoutName === option.StandardLayoutNames.Double) {
      if (this.item_details.canopy.ventMiddleFabric.length < 2) {
        this.item_details.canopy.ventMiddle = option.Panel.Solid;
      } else {
        this.item_details.canopy.ventMiddle = option.Panel.Alternating;
      }
    } else {
      this.item_details.canopy.ventMiddle = null;
      this.item_details.canopy.ventMiddleFabric = [];
    }
    // After the Phase 5 decoupling, preset is derived from vent + trim
    // together — `computePreset` is the canonical source. Trim takes
    // precedence (D1/D2/D3); vent only drives S1 / S1DV when trim is none.
    this.item_details.layout.preset = this.computePreset();
  }

  protected checkMainCanopy(): void {
    if (this.item_details.canopy.mainFabric.length > 1) {
      this.item_details.canopy.mainCanopy = option.Panel.Alternating;
    } else {
      this.item_details.canopy.mainCanopy = option.Panel.Solid;
    }
  }

  /**
   * Hydrate `layoutName` (vent) and `selectedTrimOption` (trim) from
   * the stored `canopy.layout.preset`. After the Phase 5 decoupling,
   * preset encodes both vent and trim — but layoutName is vent-only,
   * so trim comes from `presetToTrimOption`.
   */
  protected setLayoutName(): void {
    const preset = this.item_details.layout.preset;
    this.layoutName =
      preset === option.Preset.S1DV ||
      preset === option.Preset.D1 ||
      preset === option.Preset.D2 ||
      preset === option.Preset.D3
        ? // Trim presets don't encode vent directly; default to Single Vent
          // for D1/D2/D3 unless explicitly S1DV. (Legacy data may have set
          // a trim preset alongside double-vent before decoupling; the
          // S1DV case is preserved separately.)
          preset === option.Preset.S1DV
          ? option.StandardLayoutNames.Double
          : option.StandardLayoutNames.Single
        : option.StandardLayoutNames.Single;
    this.selectedTrimOption = this.presetToTrimOption(preset);
  }

  protected checkCanopyLayout(): void {
    // After the Phase 5 decoupling, preset is derived from BOTH vent
    // (layoutName) and trim (selectedTrimOption) — `computePreset` is
    // the canonical source.
    this.item_details.layout.preset = this.computePreset();
  }

  protected addToQuote(item: LineItem) {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.checkMainCanopy();
      this.checkVentMiddle();
      this.checkCanopyLayout();
      this.addNotesToQuote();
      const orderItem = { ...item, item_details: this.item_details };
      orderItem.sku = this.sku;
      // FUPOF-193: stamp provenance before the line reaches the store, so the
      // cart pill works on a store-resident line and not only after a draft
      // round-trip. The line carries the design it came from and is judged
      // against it: an umbrella the rep changed before adding keeps its code
      // and reads adjusted — as does one whose base they removed, which leaves
      // no base line to say so.
      if (this.sharedDesignId && this.sharedOrigin) {
        stampSharedDesign(orderItem, this.sharedDesignId);
        stampSharedDesignOrigin(orderItem, { ...this.sharedOrigin });
        judgeSharedDesign(
          orderItem,
          designBaseMissing(this.sharedOrigin, !!this.baseSelection)
        );
      }
      // FUPOF-193: one setup per add, minted even with No Base selected, so a
      // base added later through the setup editor has a setup to join.
      const setupId = mintSetupId();
      stampSetup(orderItem, setupId);
      this.addItem(orderItem);
      // FUPOF-193: the base and its cover land with the umbrella, so
      // abandoning the page leaves nothing orphaned in the cart.
      this.addCompanionLines(orderItem.multiplier, orderItem.qty, setupId);
      // Read by footerEditLabel once editMode is raised below. The same
      // condition addCompanionLines and companionCartInfo add lines on.
      this.savedWithCompanions = !!this.baseSelection;
      const numberPrice =
        orderItem.unit_price * orderItem.multiplier * orderItem.qty;
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        cost: numberPrice,
        model: orderItem.model,
        productline: orderItem.product_line,
        name: orderItem.display_name,
        finish: orderItem.item_details.frame.finish,
        fabric: this.item_details.canopy.mainFabric,
        fringe: this.item_details.canopy.fringe,
        fringeFabric: this.item_details.canopy.fringeFabric,
        sku: orderItem.sku,
        valance: this.item_details.canopy.valance,
        valanceFabric: this.item_details.canopy.valanceFabric,
        bindingFabric: this.item_details.canopy.bindingFabric,
        undersideFabric: this.item_details.canopy.undersideFabric,
        finial: this.item_details.frame.finial,
        finialFinish: this.item_details.frame.finialFinish,
        bottomPole: this.item_details.frame.bottomPole,
        spigot: this.item_details.frame.spigot,
        rib: this.item_details.canopy.rib,
        // BugHerd #5: this page now adds up to three lines, so the
        // confirmation has to describe all of them. Built from the same state
        // addCompanionLines builds its line items from, at the same point in
        // the method, so the two cannot describe different things.
        ...this.companionCartInfo(orderItem.multiplier, orderItem.qty)
      });
      this.editMode = true;
    } else {
      console.error("Error adding item to cart");
    }
  }

  /**
   * The base and cover half of the add-to-cart confirmation — BugHerd #5.
   *
   * Mirrors CustomizeBase's own emit field for field, so a base added from
   * here and the same base added from its own page read identically in the
   * modal. That includes rebuilding the options block the way that page does:
   * the line stores wheels in `baseOptions` and the stem alongside it, and the
   * modal wants them as one object, keyed `attachment` for a spigot and `stem`
   * for a real stem.
   *
   * `itemCount` is separate from `qty` on purpose. The modal's header counts
   * items while its body prints `qty` as the per-item quantity, and they are
   * the same field today only because this page used to add exactly one line.
   */
  private companionCartInfo(
    multiplier: number,
    qty: number
  ): Record<string, unknown> {
    const selection = this.baseSelection;
    if (!selection) return {};

    const options: Record<string, unknown> = {
      ...baseOptionsForLine(selection)
    };
    if (selection.baseStem) {
      if (selection.baseStem === SPIGOT_STEM) {
        options.attachment = selection.baseStem;
      } else {
        options.stem = selection.baseStem;
      }
    }

    const baseInfo = {
      name: selection.base.display_name,
      model: selection.base.model,
      sku: this.baseSku,
      finish: selection.baseFinish ? selection.baseFinish.handle : undefined,
      options,
      qty,
      cost: this.baseUnitPrice * multiplier * qty
    };

    const cover = selection.baseOptions.topCover;
    const coverInfo = cover
      ? {
          name: `${cover.display_name} - ${cover.finish.display_name} Finish`,
          model: `${cover.model}-${String(
            cover.finish.handle
          ).toUpperCase()}`,
          qty,
          cost: this.coverUnitPrice * multiplier * qty
        }
      : null;

    return {
      baseInfo,
      coverInfo,
      itemCount: qty * (1 + 1 + (coverInfo ? 1 : 0))
    };
  }

  /**
   * FUPOF-193: add the base the rep configured, and its top cover, as their own
   * cart lines.
   *
   * Both mirror the umbrella's qty and multiplier: a rep quoting three complete
   * setups means three bases, not one. They stay separate lines so each remains
   * editable and priced in its own right.
   *
   * No network here — the card has already priced the selection and the base
   * SKU came back with the umbrella's — so unlike the old chained add there is
   * nothing for the "added to cart" modal to wait on.
   */
  private async addCompanionLines(
    multiplier: number,
    qty: number,
    setupId: string
  ): Promise<void> {
    const selection = this.baseSelection;
    if (!selection) return;

    // Both lines carry the design's code, and each is judged against the
    // design's own base or cover — per line, independently of the umbrella:
    // editing the canopy doesn't change the base. A line the design didn't
    // have is adjusted outright, and a base whose design cover was dropped
    // says so.
    const origin = this.sharedOrigin;
    const opts = {
      multiplier,
      qty,
      shareId: this.sharedDesignId,
      sdAdjusted: true,
      setupId
    };

    const baseLine = buildBaseLine(
      selection,
      this.baseSku,
      this.baseUnitPrice,
      { ...opts, sdOrigin: origin ? origin.base : null }
    );
    judgeSharedDesign(
      baseLine,
      designCoverMissing(origin, !!topCoverLineModel(selection))
    );
    await this.addItem(baseLine);
    if (!this.baseUnitPrice) this.warnUnpriced(selection.base.model);

    const coverLine = buildTopCoverLine(selection, this.coverUnitPrice, {
      ...opts,
      sdOrigin: origin ? origin.cover : null
    });
    if (coverLine) {
      await this.addItem(coverLine);
      if (!this.coverUnitPrice) this.warnUnpriced(coverLine.model);
    }
  }

  private warnUnpriced(model: string): void {
    NotificationService.show(
      `Could not price "${model}". Please set its price in the cart.`,
      "warning",
      12000
    );
  }

  /** The base line's half of a selection: everything but the cover. */
  private baseLineKey(selection: BaseSelection | null): string {
    if (!selection) return "none";
    return baseSelectionSignature({
      ...selection,
      baseOptions: baseOptionsForLine(selection)
    });
  }

  /** The cover line's half of a selection. */
  private coverLineKey(selection: BaseSelection | null): string {
    const cover = selection ? selection.baseOptions.topCover : null;
    return cover ? `${cover.model}:${String(cover.finish.handle)}` : "none";
  }

  /**
   * A base or cover line rebuilt from the card, written over the setup member
   * it replaces. The member keeps everything the card doesn't own: its `uuid`
   * and `ns_line_id` (so NetSuite sees an update on resubmit, not a delete and
   * an add), its `type`, the rep's free-text `notes`, a multiplier pinned from
   * NetSuite, and every per-field note.
   *
   * The stem note is the one field both sides write. The cart's notes modal
   * gives every base line a Stem box the rep types into, and the card owns the
   * fixed Spigot / beauty-plate text in front of it. So it is taken apart the
   * way CustomizeBase.setNotes() does — the old fixed text stripped off the
   * rep's — and put back together the way addNotesToQuote() does, with the
   * fixed text baseStemNotes just computed for the new selection in front.
   *
   * Deliberately the fresh line plus a whitelist, not `{ ...existing }`: that
   * would carry anything describing the old configuration or its price onto a
   * line that was just rebuilt and re-priced. The Shade Designer code is
   * whitelisted explicitly, and marked adjusted.
   */
  private mergeIntoMember(existing: LineItem, fresh: LineItem): LineItem {
    const freshDetails = (fresh.item_details ?? {}) as { notes?: Note[] };
    const existingDetails = existing.item_details as
      | { notes?: Note[] }
      | undefined;
    const existingNotes = existingDetails?.notes ?? [];
    const freshNotes = freshDetails.notes ?? [];
    const fixedStem = freshNotes.find(note => note.field === NoteFields.Stem);
    const oldStem = existingNotes.find(note => note.field === NoteFields.Stem);
    const repStem = oldStem
      ? oldStem.content
          .replace(SPIGOT_NOTE, "")
          .trim()
          .replace(BEAUTY_PLATE_NOTE, "")
          .trim()
      : "";
    const stemNote: Note = {
      field: NoteFields.Stem,
      content: [fixedStem ? fixedStem.content : "", repStem]
        .filter(Boolean)
        .join(" ")
    };
    // The stem note takes the old one's place; a record the line had stays,
    // even when it is now empty, and one is only added when there is text.
    const notes = existingNotes.map(note =>
      note.field === NoteFields.Stem ? stemNote : note
    );
    if (!oldStem && stemNote.content) notes.push(stemNote);
    notes.push(
      ...freshNotes.filter(
        note =>
          note.field !== NoteFields.Stem &&
          !existingNotes.some(kept => kept.field === note.field)
      )
    );
    const merged: LineItem = {
      ...fresh,
      item_details: {
        ...freshDetails,
        notes
      } as LineItem["item_details"],
      notes: existing.notes ?? ""
    };
    // A rebuilt member keeps its own code — it is still where the line came
    // from — and its origin, and is judged against that: a base set back to
    // the design's own reads as designed again. With no origin to judge by,
    // a rebuilt member is marked adjusted.
    const code = sharedDesignCode(existing);
    const origin = sharedDesignOrigin(existing) ?? sharedDesignOrigin(fresh);
    if (code) {
      stampSharedDesign(merged, code);
      if (origin) stampSharedDesignOrigin(merged, origin);
      if (!judgeSharedDesign(merged)) markSharedDesignAdjusted(merged);
    }
    if (existing.type) merged.type = existing.type;
    if (existing.uuid) merged.uuid = existing.uuid;
    if (existing.ns_line_id) merged.ns_line_id = existing.ns_line_id;
    if (existing.ns_multiplier) {
      merged.ns_multiplier = true;
      merged.multiplier = existing.multiplier;
    }
    return merged;
  }

  /**
   * FUPOF-193: the whole cart as it reads once this setup is saved — the
   * umbrella, and its base and cover — for ONE replaceLineItems commit.
   *
   * Every member is resolved here, by setup id against the store as it is now
   * (the shared render rule, utility/line_setup), never by indices captured at
   * load. Members are replaced in place.
   *
   * NO DUPLICATE BASES: a base (or cover) line is only ever *inserted* when the
   * store holds no line of that type carrying this setup id. Every other path
   * replaces the existing line or leaves it alone.
   *
   * Qty: every member takes the umbrella's new qty — line_setup.syncSetupQty,
   * the same rule the cart's umbrella stepper applies.
   *
   * Shade Designer: a line keeps its code for good. Adding, removing or
   * replacing the base or cover changes the design, so the umbrella is marked
   * adjusted — it is the one line certain to still be here to say so, and the
   * cart reads "adjusted" across the whole setup.
   *
   * @param anchorIndex the umbrella's index, from `?cart=`.
   * @param umbrella the umbrella line as it will be saved.
   */
  private buildSetupItems(anchorIndex: number, umbrella: LineItem): LineItem[] {
    const store = this.storeItems;
    const newQty = umbrella.qty;
    const selection = this.baseSelection;

    let setupId = setupIdOf(umbrella);
    if (!setupId && selection) {
      // An umbrella from before setups existed, or one from NetSuite: choosing
      // a base here starts its setup.
      setupId = mintSetupId();
      stampSetup(umbrella, setupId);
    }
    const group = setupId ? setupGroupAt(store, anchorIndex) : null;
    const baseAt = group ? group.base : null;
    const coverAt = group ? group.cover : null;
    const inStore = (type: ProductType): boolean =>
      store.some(
        (line, i) =>
          i !== anchorIndex &&
          line.product_type === type &&
          setupIdOf(line) === setupId
      );

    const items = [...store];
    items[anchorIndex] = umbrella;
    const remove: number[] = [];
    const afterAnchor: LineItem[] = [];
    const afterBase: LineItem[] = [];
    /** A base or cover line was added, removed or replaced. */
    let designChanged = false;

    // The card never showed this setup's base — it is still settling, or it
    // can't offer the base any more — so the rep has decided nothing about it.
    // Nothing for the card to write either when there's no base and none was
    // chosen; a stray cover with no base (NetSuite removed only the base) is
    // not the card's to manage.
    const baseUntouched =
      baseAt !== null && (this.awaitingBaseSettle || this.baseMemberUnresolved);
    if (baseUntouched || (baseAt === null && !selection)) {
      return syncSetupQty(items, anchorIndex);
    }

    if (!selection) {
      // No Base, chosen on purpose, where the setup had one: the rep was told
      // by the card's note that this removes the base and its cover.
      remove.push(baseAt as number);
      if (coverAt !== null) remove.push(coverAt);
      designChanged = true;
    } else {
      // A line added to a design after the fact carries its code. It is
      // judged against the design's own base or cover, which the umbrella
      // carries — a base removed and then put back reads as designed — and
      // with no design to judge it by, isn't as designed.
      const umbrellaOrigin = sharedDesignOrigin(umbrella);
      const lineOpts = {
        multiplier: umbrella.multiplier,
        qty: newQty,
        shareId: sharedDesignCode(umbrella),
        sdAdjusted: true,
        setupId: setupId as string
      };
      const baseOpts = {
        ...lineOpts,
        sdOrigin: umbrellaOrigin ? umbrellaOrigin.base : null
      };
      const coverOpts = {
        ...lineOpts,
        sdOrigin: umbrellaOrigin ? umbrellaOrigin.cover : null
      };

      // Base. Unchanged: not rebuilt or re-priced at all.
      if (baseAt !== null) {
        if (this.baseLineKey(selection) !== this.loadedBaseKey) {
          items[baseAt] = this.mergeIntoMember(
            store[baseAt],
            buildBaseLine(selection, this.baseSku, this.baseUnitPrice, baseOpts)
          );
          designChanged = true;
          if (!this.baseUnitPrice) this.warnUnpriced(selection.base.model);
        }
      } else if (!inStore(ProductType.Base)) {
        // The only place a base line is ever inserted: directly after the
        // umbrella, so the setup stays contiguous.
        afterAnchor.push(
          buildBaseLine(selection, this.baseSku, this.baseUnitPrice, baseOpts)
        );
        designChanged = true;
        if (!this.baseUnitPrice) this.warnUnpriced(selection.base.model);
      } else {
        // A base carrying this setup id sits somewhere the render rule doesn't
        // count as a member. No write in this app produces that, but adding
        // another would be the duplicate this method exists to prevent.
        NotificationService.show(
          "This umbrella already has a base elsewhere on the quote, so another was not added.",
          "warning",
          12000
        );
      }

      // Cover.
      const coverLine = buildTopCoverLine(
        selection,
        this.coverUnitPrice,
        coverOpts
      );
      if (coverAt !== null) {
        if (!coverLine) {
          // Only a cover the card was showing is removed. With no base in
          // the setup at load, the card never showed this one.
          if (baseAt !== null) {
            remove.push(coverAt);
            designChanged = true;
          }
        } else if (
          baseAt === null ||
          this.coverLineKey(selection) !== this.loadedCoverKey
        ) {
          items[coverAt] = this.mergeIntoMember(store[coverAt], coverLine);
          designChanged = true;
          if (!this.coverUnitPrice) this.warnUnpriced(coverLine.model);
        }
      } else if (coverLine && !inStore(ProductType.Accessory)) {
        // Inserted directly after its base, wherever that base now sits.
        (baseAt !== null ? afterBase : afterAnchor).push(coverLine);
        designChanged = true;
        if (!this.coverUnitPrice) this.warnUnpriced(coverLine.model);
      } else if (coverLine) {
        // As for the base above: a cover with this setup id sits outside the
        // setup, and adding another would duplicate it. Say so rather than
        // dropping the rep's choice silently.
        NotificationService.show(
          "This umbrella already has a top cover elsewhere on the quote, so another was not added.",
          "warning",
          12000
        );
      }
    }

    // An umbrella with an origin is judged once the setup is final (see
    // judgeSetupAnchor); without one, a changed setup is marked adjusted.
    if (designChanged && !sharedDesignOrigin(umbrella)) {
      markSharedDesignAdjusted(umbrella);
    }

    const result: LineItem[] = [];
    items.forEach((line, i) => {
      if (remove.indexOf(i) === -1) result.push(line);
      if (i === anchorIndex) result.push(...afterAnchor);
      if (i === baseAt) result.push(...afterBase);
    });
    return syncSetupQty(result, anchorIndex);
  }

  /**
   * FUPOF-193: the cart line View Cart lands on after an Update. Opened from a
   * base or cover pencil (`section=base`), that's the setup's base — the line
   * the rep was looking at, with its cover directly under it — or the
   * umbrella when the base has since gone. Otherwise the umbrella.
   */
  private editedCartLine(items: LineItem[], anchorIndex: number): number {
    if (this.$route.query.section !== "base") return anchorIndex;
    const group = setupGroupAt(items, anchorIndex);
    return group && group.base !== null ? group.base : anchorIndex;
  }

  /**
   * FUPOF-193: judge the setup against its design once it is final. The
   * umbrella answers for its own configuration and for a design base that is
   * gone; the base for its own and for a design cover that is gone. Only the
   * umbrella records what the design's base and cover were.
   *
   * The base may still be the store's own object (an untouched member), so
   * it is copied before its flag is written.
   */
  private judgeSetupAnchor(items: LineItem[], anchorIndex: number): void {
    const umbrella = items[anchorIndex];
    const origin = sharedDesignOrigin(umbrella);
    const group = setupGroupAt(items, anchorIndex);
    const hasBase = !!group && group.base !== null;
    judgeSharedDesign(umbrella, designBaseMissing(origin, hasBase));
    if (!group || group.base === null || !origin) return;
    const base = items[group.base];
    const copy: LineItem = {
      ...base,
      item_details: base.item_details
        ? ({ ...base.item_details } as LineItem["item_details"])
        : base.item_details
    };
    const coverMissing = designCoverMissing(origin, group.cover !== null);
    if (judgeSharedDesign(copy, coverMissing)) items[group.base] = copy;
  }

  /**
   * After a save, re-point the load-time snapshot at what was just written, so
   * a second Update from this same page compares against the lines as they now
   * stand rather than as they were when the page opened.
   */
  private rememberSavedSetup(items: LineItem[], anchorIndex: number): void {
    const group = setupGroupAt(items, anchorIndex);
    const selection = this.baseSelection;
    this.loadedBaseMember =
      group && group.base !== null ? items[group.base] : null;
    this.loadedHasCover = !!group && group.cover !== null;
    if (this.awaitingBaseSettle || this.baseMemberUnresolved) return;
    this.loadedBaseKey = this.baseLineKey(selection);
    this.loadedCoverKey = this.coverLineKey(selection);
  }

  protected editQuote(item: LineItem) {
    const index = parseInt(this.$route.query.cart as string, 10);
    this.$v.$touch();
    if (!this.$v.$invalid) {
      if (this.item_details.canopy.mainFabric.length > 1) {
        this.item_details.canopy.mainCanopy = option.Panel.Alternating;
      } else {
        this.item_details.canopy.mainCanopy = option.Panel.Solid;
      }
      this.addNotesToQuote();
      // The footer's lineItem doesn't carry NetSuite line identity
      // (ns_line_id, ns_locked). Merge the edited fields onto the original
      // stored line so a NetSuite-added/linked line keeps its identity and is
      // still recognized as an update — not a brand-new line — on resubmit.
      const original = this.storeItems[index];
      const orderItem = {
        ...original,
        ...item,
        item_details: this.item_details
      };
      orderItem.sku = this.sku;
      // FUPOF-193: the code stays for good — it is still where the line came
      // from. A line that carries its design is judged against it once the
      // setup is built, so setting a change back clears "adjusted". One from
      // before origins existed is marked adjusted on any change (sticky).
      const origin = sharedDesignOrigin(original);
      if (origin) {
        stampSharedDesignOrigin(orderItem, origin);
      } else if (!this.isUnchangedSharedDesign) {
        markSharedDesignAdjusted(orderItem);
      }
      // FUPOF-193: the umbrella and its setup's base and cover are written
      // together, in one commit, so the cart is never seen half-updated. The
      // setup id itself rides along on `...original`.
      const items = this.buildSetupItems(index, orderItem);
      this.judgeSetupAnchor(items, index);
      this.replaceLineItems(items);
      this.rememberSavedSetup(items, index);
      const numberPrice =
        orderItem.unit_price * orderItem.multiplier * orderItem.qty;
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        cost: numberPrice,
        model: orderItem.model,
        productline: orderItem.product_line,
        name: orderItem.display_name,
        finish: orderItem.item_details.frame.finish,
        fabric: this.item_details.canopy.mainFabric,
        fringe: this.item_details.canopy.fringe,
        fringeFabric: this.item_details.canopy.fringeFabric,
        sku: orderItem.sku,
        valance: this.item_details.canopy.valance,
        valanceFabric: this.item_details.canopy.valanceFabric,
        bindingFabric: this.item_details.canopy.bindingFabric,
        undersideFabric: this.item_details.canopy.undersideFabric,
        finial: this.item_details.frame.finial,
        finialFinish: this.item_details.frame.finialFinish,
        bottomPole: this.item_details.frame.bottomPole,
        spigot: this.item_details.frame.spigot,
        rib: this.item_details.canopy.rib,
        // The base and cover, described exactly as addToQuote describes them.
        ...this.companionCartInfo(orderItem.multiplier, orderItem.qty),
        cartLine: this.editedCartLine(items, index)
      });
    }
  }

  protected toggleModal(field: NoteFields): void {
    this.showNoteModal[field] = true;
  }

  protected closeModal(): void {
    this.showNoteModal = {
      model: false,
      canopy: false,
      frame: false,
      valance: false,
      fringe: false,
      bottomPole: false,
      finial: false,
      rib: false,
      spigot: false
    };
  }

  protected showFabricSelector(
    selection: FabricComponent,
    swatch: FabricSwatch | null,
    index = null
  ): void {
    this.$v.$reset();
    this.swatch = swatch;
    this.index = index;
    // For the main canopy panels, the component name is derived from the
    // slot index rather than the caller-supplied selection: index 0 is the
    // primary Main panel, anything higher is an alternating panel. This
    // keeps the picker's title in sync even when the template fires
    // `MainAlternating` for every multi-panel swatch tile.
    if (
      selection === FabricComponent.Main ||
      selection === FabricComponent.MainAlternating
    ) {
      this.component =
        this.index !== null && this.index > 0
          ? FabricComponent.MainAlternating
          : FabricComponent.Main;
    } else {
      this.component = selection;
    }
    this.fabricSelectorVisible = true;
  }

  protected changeSelectedModel(item: UmbrellaModel): void {
    // Defense for direct invocations (e.g. mobile Dropdown). When the
    // target model is disabled for the current striped-fabric state,
    // revert to whatever was previously selected.
    if (this.isModelDisabledForStripes(item)) {
      if (this.selected) {
        this.model = this.selected.model;
      }
      return;
    }
    const wasGrommetOnly = this.isGrommetOnlyModel;
    this.selected = item;
    this.model = item.model;
    const nowGrommetOnly = grommetOnlyModels.includes(item.model);

    if (nowGrommetOnly && !wasGrommetOnly) {
      // Entering a grommet-only model: save current rib and auto-switch
      this.ribBeforeAutoSwitch = this.item_details.canopy.rib;
      this.ribAutoSwitchedToGrommets = true;
      this.suppressRibWatch = true;
      this.item_details.canopy.rib = option.Rib.Grommets;
      this.item_details.canopy.ribFabric = null;
      this.$nextTick(() => { this.suppressRibWatch = false; });
    } else if (!nowGrommetOnly && wasGrommetOnly && this.ribAutoSwitchedToGrommets) {
      // Leaving a grommet-only model and user never manually chose grommets: restore
      this.suppressRibWatch = true;
      this.item_details.canopy.rib = this.ribBeforeAutoSwitch;
      if (this.item_details.canopy.rib !== option.Rib.Pockets) {
        this.item_details.canopy.ribFabric = null;
      }
      this.ribAutoSwitchedToGrommets = false;
      this.ribBeforeAutoSwitch = null;
      this.$nextTick(() => { this.suppressRibWatch = false; });
    } else if (nowGrommetOnly && wasGrommetOnly) {
      // Switching between grommet-only models: keep forced grommets, preserve saved rib
      this.suppressRibWatch = true;
      this.item_details.canopy.rib = option.Rib.Grommets;
      this.item_details.canopy.ribFabric = null;
      this.$nextTick(() => { this.suppressRibWatch = false; });
    }

    this.clearRestrictedUndersideFabric();
    this.clearRestrictedBullionFringe();
  }

  /**
   * Drop an underside fabric the current configuration can't carry — either
   * the model doesn't support the layer, or the canopy is double-vented.
   *
   * Called both when the model changes and when an existing cart item is
   * hydrated for edit — a line item saved before this restriction existed
   * would otherwise load with the underside fabric still attached, and the
   * picker is disabled so the user can't clear it by hand.
   */
  protected clearRestrictedUndersideFabric(): void {
    if (this.isUndersideDisabled && this.item_details.canopy.undersideFabric) {
      this.item_details.canopy.undersideFabric = null;
    }
  }

  /**
   * Drop a 3"/5" bullion that the current model can't carry, so it cannot
   * reach the line item, cart or checkout. The onFringeChange watcher
   * clears fringeFabric off the back of this.
   *
   * Called both when the model changes and when an existing cart item is
   * hydrated for edit — a line item saved before this restriction existed
   * would otherwise load with the restricted fringe still selected.
   */
  protected clearRestrictedBullionFringe(): void {
    if (
      this.isBullionRestrictedByModel &&
      (this.item_details.canopy.fringe === option.Fringe.Bullion3 ||
        this.item_details.canopy.fringe === option.Fringe.Bullion5)
    ) {
      this.item_details.canopy.fringe = option.Fringe.None;
    }
  }

  get maxFringeFabrics(): number {
    return this.item_details.canopy.fringe === option.Fringe.Brush ? 2 : 3;
  }

  get umbrellas(): UmbrellaModel[] {
    return this.items as UmbrellaModel[];
  }

  get finishes(): UmbrellaModel["finishes"] {
    return this.selected!.finishes.sort((a, b) =>
      a.handle > b.handle ? 1 : -1
    );
  }

  protected deleteMainSwatch(index: number): void {
    this.item_details.canopy.mainFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }

  protected deleteVentSwatch(index: number): void {
    this.item_details.canopy.ventTopFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }

  protected deleteMiddleVentSwatch(index: number): void {
    this.item_details.canopy.ventMiddleFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }

  protected deleteOuterTrimSwatch(): void {
    this.item_details.canopy.mainTrimFabric = null;
    this.updatePriceAndSKU();
  }

  protected deleteInnerTrimSwatch(): void {
    this.item_details.canopy.mainTrimFabricInner = null;
    this.updatePriceAndSKU();
  }

  protected deleteUndersideSwatch(): void {
    this.item_details.canopy.undersideFabric = null;
    this.updatePriceAndSKU();
  }

  get isDoubleVent(): boolean {
    return this.layoutName === option.StandardLayoutNames.Double;
  }

  private readonly noUndersideModels = ["876FMA-R", "882FMC-R"];

  get isUndersideDisabledByModel(): boolean {
    return this.selected?.model != null && this.noUndersideModels.includes(this.selected.model);
  }

  get isUndersideDisabled(): boolean {
    return this.isDoubleVent || this.isUndersideDisabledByModel;
  }

  /**
   * The 3" and 5" bullion fringes are too heavy for these canopies — the
   * same weight rationale behind `noUndersideModels` above. The 1" brush
   * fringe stays available. Mirrors shade-designer.
   */
  private readonly noBullionFringeModels = ["876FMA-R", "882FMC-R"];

  /**
   * Every model that cannot carry the 3"/5" bullion fringes, listed in full
   * and shown at all times rather than keyed off the current selection.
   * Read from the exclusion list above so the copy can't drift from the rule
   * that actually gates the options. Mirrors shade-designer.
   */
  get restrictedBullionModels(): string {
    const models = this.noBullionFringeModels;
    if (models.length < 2) return models.join("");
    return (
      models.slice(0, -1).join(", ") + " and " + models[models.length - 1]
    );
  }

  get isBullionRestrictedByModel(): boolean {
    return (
      this.selected?.model != null &&
      this.noBullionFringeModels.includes(this.selected.model)
    );
  }

  /**
   * 5" Bullion fringe is incompatible with the French and Roman valance
   * styles (the long bullion strands physically interfere with those
   * scalloped/draped valance shapes). Mirrors shade-designer.
   *
   * Bidirectional disable:
   *   - isBullion5RestrictedByValance: true when the current valance is
   *     French or Roman — used to disable the 5" Bullion fringe option.
   *   - disabledValances: returns the list of valance values to disable
   *     when 5" Bullion is currently selected.
   */
  get isBullion5RestrictedByValance(): boolean {
    return (
      this.item_details.canopy.valance === option.Valance.French ||
      this.item_details.canopy.valance === option.Valance.Roman
    );
  }

  get disabledValances(): option.Valance[] {
    return this.item_details.canopy.fringe === option.Fringe.Bullion5
      ? [option.Valance.French, option.Valance.Roman]
      : [];
  }

  protected isFringeOptionDisabled(fringeOption: option.Fringe): boolean {
    if (
      fringeOption === option.Fringe.Bullion5 &&
      this.isBullion5RestrictedByValance
    ) {
      return true;
    }
    return (
      (fringeOption === option.Fringe.Bullion3 ||
        fringeOption === option.Fringe.Bullion5) &&
      this.isBullionRestrictedByModel
    );
  }

  /**
   * The mobile Dropdown renders a plain list with no per-option disabled
   * state, so restricted fringes have to be filtered out of its data rather
   * than greyed out the way the desktop radio list does.
   */
  get availableFringeOptions(): option.Fringe[] {
    return (Object.values(option.Fringe) as option.Fringe[]).filter(
      f => !this.isFringeOptionDisabled(f)
    );
  }

  protected isValanceOptionDisabled(valance: option.Valance): boolean {
    return this.disabledValances.includes(valance);
  }

  /**
   * Designer Trim (Single / Double / Triple) is incompatible with
   * alternating main canopy fabrics and alternating valance fabrics —
   * the trim runs as one continuous band and can't accommodate a
   * mid-panel fabric switch on either component. Double-vent
   * alternating IS allowed alongside trim.
   *
   * Bidirectional disable (mirrors Bullion5 ↔ French/Roman valance):
   *   - `isTrimRestrictedByAlternating` (true when main canopy OR
   *     valance has > 1 fabric) → disables Single / Double / Triple
   *     trim buttons; "No Trim" remains selectable.
   *   - The reciprocal "main canopy / valance add-fabric tile hidden
   *     while trim is active" is enforced in the template via
   *     `selectedTrimOption === 'none'` v-if guards on those tiles.
   */
  get isTrimRestrictedByAlternating(): boolean {
    const mainAlt =
      (this.item_details.canopy.mainFabric as FabricSwatch[]).length > 1;
    const valanceAlt =
      (this.item_details.canopy.valanceFabric as FabricSwatch[]).length > 1;
    return mainAlt || valanceAlt;
  }

  /**
   * True when the current user does NOT have the Admin role. Admins
   * are exempt from the stripe restrictions (they can mix striped
   * fabrics with designer trims and rectangle umbrellas for special
   * orders); everyone else is blocked. Stripes are the only thing
   * rectangle shape restricts — trims stay available on all shapes.
   */
  get isNonAdmin(): boolean {
    return this.userRole !== Roles.Admin;
  }

  /**
   * True when the active umbrella's canopy shape is rectangular.
   * Rectangle canopies cannot use striped fabrics because the pattern
   * doesn't lay correctly across the asymmetric panels.
   */
  get isRectangleUmbrella(): boolean {
    return this.isRectangleShape(this.selected);
  }

  protected isRectangleShape(
    model: UmbrellaModel | null | undefined
  ): boolean {
    const shape = model?.shape;
    return (
      Array.isArray(shape) &&
      shape.length > 0 &&
      shape[0].toLowerCase() === "rectangle"
    );
  }

  /**
   * Detects whether any saved canopy-region fabric (main, vent top,
   * vent middle, valance) is striped. Trim and underside aren't
   * considered because they wouldn't be striped in the restricted state
   * to begin with.
   */
  protected isStripedFabric(swatch: FabricSwatch | null | undefined): boolean {
    return (
      !!swatch?.pattern_group && swatch.pattern_group.includes("Stripes")
    );
  }

  get hasStripedCanopyFabric(): boolean {
    const arrays: (FabricSwatch | null | undefined)[][] = [
      this.item_details.canopy.mainFabric as FabricSwatch[],
      this.item_details.canopy.ventTopFabric as FabricSwatch[],
      this.item_details.canopy.ventMiddleFabric as FabricSwatch[],
      this.item_details.canopy.valanceFabric as FabricSwatch[]
    ];
    for (const arr of arrays) {
      if (arr && arr.some(f => this.isStripedFabric(f))) return true;
    }
    return false;
  }

  /**
   * True when non-admin users should be prevented from enabling a
   * Designer Trim layout — happens when any saved canopy fabric is
   * striped. Mirrors the alternating-panel restriction. Canopy shape
   * and size never restrict trim: trims are offered on every shape
   * (rectangles included) and every size.
   */
  get isTrimRestrictedByStripes(): boolean {
    return this.isNonAdmin && this.hasStripedCanopyFabric;
  }

  /**
   * Block non-admin users from switching to a rectangle umbrella model
   * while any saved canopy fabric is striped. Stripes don't lay
   * correctly on rectangle canopies; flipping the model would silently
   * create an invalid combination. The model picker disables matching
   * options with a tooltip explaining the conflict — the user has to
   * change the striped fabric first, or stay on the current shape.
   */
  protected isModelDisabledForStripes(model: UmbrellaModel): boolean {
    return (
      this.isNonAdmin &&
      this.isRectangleShape(model) &&
      this.hasStripedCanopyFabric
    );
  }

  protected isTrimOptionDisabled(
    trimValue: "none" | "single" | "double" | "triple"
  ): boolean {
    if (trimValue === "none") return false;
    return (
      this.isTrimRestrictedByAlternating || this.isTrimRestrictedByStripes
    );
  }

  /**
   * `forceNoStripes` is passed to the FabricSelector when the active
   * picker should hide Stripes from the Design filter. True when the
   * user is non-admin AND (the canopy has a trim layout active OR the
   * umbrella is rectangular). Fringe / binding pickers are intentionally
   * skipped — those don't show Design at all.
   */
  protected isStripeRestrictedComponent(
    component: FabricComponent | null
  ): boolean {
    if (!component) return false;
    if (
      component === FabricComponent.Fringe ||
      component === FabricComponent.Binding ||
      component === FabricComponent.ChairBinding
    ) {
      return false;
    }
    return (
      this.isNonAdmin &&
      (this.selectedTrimOption !== "none" || this.isRectangleUmbrella)
    );
  }

  get forceNoStripesForActiveComponent(): boolean {
    return this.isStripeRestrictedComponent(this.component);
  }

  protected deleteValanceSwatch(index: number): void {
    this.item_details.canopy.valanceFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }

  protected deleteFringeSwatch(index: number): void {
    this.item_details.canopy.fringeFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }
}
